import {
  message,
  Tabs,
  Select,
  PageHeader,
  Spin,
  Row,
  Col,
  Space,
  Popconfirm,
  Tooltip,
  Form as FormInitial,
  Dropdown,
  Menu,
  Alert,
  Tag,
  Collapse,
  Modal,
} from "antd";
import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  ButtonItem,
  InputItem,
  TextAreaItem,
  DatePickerItem,
  SelectItem,
  InputNumberItem,
  round10Decimals,
  round2Decimals,
  dineroDisabledMask,
  TableItem,
  round6Decimals,
  SwitchItem,
  round4Decimals,
  TreeSelectItem,
  SelectInsumosItem,
  TabbedDynamicTable,
  MensajeError,
  ErrorItem,
} from "../../../../Components/Items";
import moment from "moment";
import {
  CalculatorOutlined,
  CheckOutlined,
  DeleteOutlined,
  DownOutlined,
  ExclamationOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  FileDoneOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import * as XLSXStyle from "xlsx-js-style";
import "moment/locale/es";
import GanttPresupuesto from "./GanttPresupuesto/GanttPresupuesto";
import numeroALetra from "../../../../Components/numeroALetra";
import reporteMatricesPdf from "../../../../Pdf/reporteMatricesPdf";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import reportePresupuestoPUPdf from "../../../../Pdf/reportePresupuestoPU";
import { etiquetaUnidadTiempo, minutosAUnidad, unidadAMinutos } from "../OrdenesDeProduccionPU/PlaneacionProduccionPU/planeacion.utils";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

moment.locale("es");

const { TabPane } = Tabs;
const { Option } = Select;
const { Panel } = Collapse;

class PresupuestoPU extends Component {
  formRef = React.createRef();
  // Maps por _id de todasMatrices/todasInsumos
  matricesPorId = new Map();
  insumosPorId = new Map();
  unidadesPorId = new Map();
  state = {
    loading: false,
    buscarInfoCode: false,
    archivosPrincipal: [],
    archivosTecnica: [],
    archivosFotos: [],
    todasMatrices: null,
    loadingExplosion: false,
    loadingReportes: false,
    loadingTabla: false,
    todasInsumos: null,
    objetoInsumos: null,
    todasProyectos: null,
    objetoProyectos: null,
    insumosExplosionados: [],
    costoTotalIE: 0,
    partidasArbol: [],
    partidas: [],
    keyEditing: "",
    expandedRowKeys: [],
    confirmado: false,
    autorizado: false,
    superado: false,
    estado: 1,
    versionNumero: 1,
    versiones: [],
    id: this.props?.location?.state?.id,
    valueExplosion: [],
    objectExplosiones: null,
    producciones: [],
    historialCargado: false,
    loadingHistorial: false,
    tipoInsumos: [],
    objetoUnidades: null,
    ordenesProduccionPresupuesto: [],
    matrizBasePorPieza: {},
    erroresPartidas: {},
  };
  atras() {
    this.props.history.goBack();
  }
  componentDidMount() {
    this.consultarTodo();
    this.cargarOrdenesProduccionParaRequerir();
  }

  cargarOrdenesProduccionParaRequerir() {
    if (!this.state.id) return;
    axios
      .post(
        "ordenesDeProduccionPU/selectTodasOrdenes",
        { empresaId: this.props.empresaId, presupuestoPUId: this.state.id, pageSize: 500 },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ ordenesProduccionPresupuesto: res.data.data || [] });
        }
      });
  }

  generarPiezaId() {
    return "pza_" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  }

  crearPiezaVacia(rootIndex) {
    return {
      tipo: 0,
      nombre: "",
      unidad: "",
      cantidad: 1,
      costo: 0,
      costoTotal: 0,
      costoCImpuestos: 0,
      costoTotalCImpuestos: 0,
      key: String(rootIndex),
      piezaId: this.generarPiezaId(),
      children: [],
    };
  }

  asegurarAlMenosUnaPieza(partidas) {
    if (partidas && partidas.length > 0) return partidas;
    return [this.crearPiezaVacia(0)];
  }

  agregarPieza() {
    const partidas = [...this.state.partidas, this.crearPiezaVacia(this.state.partidas.length)];
    this.setState({ partidas });
  }

  aplanarPartidasLegacy(partidas) {
    if (!partidas || partidas.length === 0) return partidas;

    return partidas.map((raiz, rootIndex) => {
      const piezaId = raiz.piezaId || this.generarPiezaId();
      const yaEsPlana = (raiz.children || []).every((hijo) => hijo.tipo === 1);
      if (yaEsPlana) return { ...raiz, piezaId };

      const matricesAplanadas = [];

      const recolectar = (nodos, acumulado) => {
        for (const nodo of nodos || []) {
          if (nodo.tipo === 1) {
            matricesAplanadas.push({
              ...nodo,
              cantidad: round10Decimals((nodo.cantidad || 0) * acumulado),
            });
          } else if (nodo.tipo === 0) {
            const factor = nodo.calculo ? (nodo.cantidad || 0) / 100 : nodo.cantidad || 0;
            recolectar(nodo.children, acumulado * factor);
          }
        }
      };
      recolectar(raiz.children, 1);

      MensajeError({
        message: `Pieza "${raiz.nombre || rootIndex + 1}" aplanada`,
        description:
          "Esta pieza tenía sub-partidas anidadas; se aplanó a una sola lista de matrices. Los cambios no se guardan hasta que presiones Guardar.",
      });

      return {
        ...raiz,
        piezaId,
        tipo: 0,
        key: String(rootIndex),
        children: matricesAplanadas.map((matriz, index) => ({
          ...matriz,
          key: rootIndex + "-" + index,
        })),
      };
    });
  }
  async consultarTodo() {
    this.setState({ loading: true });

    const peticiones = [
      axios.post(
        "presupuestosPU/selectDatosParaPresupuestoPU",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      ),
    ];

    if (this.state.id) {
      peticiones.push(
        axios.post(
          "presupuestosPU/datosPresupuesto",
          { empresaId: this.props.empresaId, presupuestoId: this.state.id },
          { headers: this.props.headersToken },
        ),
      );
    }

    const [resCatalogo, resPresupuesto] = await Promise.all(peticiones);

    const nuevoState = {};

    if (resCatalogo.data.status !== 404) {
      // El catálogo de matrices/insumos se resuelve acotado más abajo
      const unidades = resCatalogo.data.unidades || [];
      this.unidadesPorId = new Map(
        unidades.map((value) => [
          value._id.toString(),
          value.unidadSat?.c_ClaveUnidad ? `${value.unidadSat.c_ClaveUnidad} - ${value.nombre}` : value.nombre,
        ]),
      );

      Object.assign(nuevoState, {
        todasProyectos: resCatalogo.data.proyectos,
        tipoInsumos: resCatalogo.data.tipoInsumos,
        objetoProyectos: resCatalogo.data.proyectos.map((value) => (
          <Option value={value._id} key={value._id}>
            {value.nombre}
          </Option>
        )),
        objetoUnidades: unidades.map((value) => (
          <Option value={value._id} key={value._id}>
            {this.unidadesPorId.get(value._id.toString())}
          </Option>
        )),
      });
    }

    if (this.state.id && resPresupuesto) {
      if (resPresupuesto.data.success === 2) {
        // Catálogo acotado a las matrices/insumos que usa este presupuesto
        const todasMatrices = resPresupuesto.data.matrices || [];
        const todasInsumos = resPresupuesto.data.insumos || [];

        this.matricesPorId = new Map(
          todasMatrices.map((value) => [value._id.toString(), value]),
        );
        this.insumosPorId = new Map(
          todasInsumos.map((value) => [value._id.toString(), value]),
        );

        this.formRef.current.setFieldsValue({
          ...resPresupuesto.data.presupuesto,
          fechaInicio: moment(resPresupuesto.data.presupuesto.fechaInicio),
          fechaFinal: moment(resPresupuesto.data.presupuesto.fechaFinal),
        });

        const partidasAplanadas = this.aplanarPartidasLegacy(
          resPresupuesto.data.presupuesto.partidas,
        );
        const nuevasPartidas = resPresupuesto.data.presupuesto.confirmado
          ? partidasAplanadas
          : this.calcularPresupuesto(partidasAplanadas);

        Object.assign(nuevoState, {
          todasMatrices,
          todasInsumos,
          partidas: nuevasPartidas,
          confirmado: resPresupuesto.data.presupuesto.confirmado,
          autorizado: resPresupuesto.data.presupuesto.autorizado,
          superado: resPresupuesto.data.presupuesto.superado,
          estado: resPresupuesto.data.presupuesto.estado,
          versionNumero: resPresupuesto.data.presupuesto.versionNumero,
          versiones: resPresupuesto.data.versiones || [],
          // Historial de explosiones/producciones se carga aparte (lazy, tab Historial)
          objectExplosiones: null,
          producciones: [],
          historialCargado: false,
        });
      } else {
        MensajeError({ message: "Error no se encontro informacion del presupuesto" });
      }
    } else if (!this.state.id) {
      // Presupuesto nuevo: catálogo vacío, se llena en onSeleccionarMatriz
      this.matricesPorId = new Map();
      this.insumosPorId = new Map();
      Object.assign(nuevoState, {
        todasMatrices: [],
        todasInsumos: [],
        partidas: this.asegurarAlMenosUnaPieza([]),
      });
    }

    this.setState({ ...nuevoState, loading: false });
  }

  async cargarHistorialPresupuesto() {
    if (!this.state.id || this.state.historialCargado) return;

    this.setState({ loadingHistorial: true });

    const partidasArbolHistorial = this.construirArbolHistorial(
      this.state.partidas,
    );

    await axios
      .post(
        "presupuestosPU/datosHistorialPresupuesto",
        { empresaId: this.props.empresaId, presupuestoId: this.state.id },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          // Mergea insumos del historial sin pisar los ya cargados
          for (const valueInsumoHistorial of res.data.insumosHistorial || []) {
            if (!this.insumosPorId.has(valueInsumoHistorial._id.toString())) {
              this.insumosPorId.set(
                valueInsumoHistorial._id.toString(),
                valueInsumoHistorial,
              );
            }
          }

          const objectExplosiones =
            res.data.explosiones && res.data.explosiones.length > 0
              ? res.data.explosiones.map((valueEI, indexEI) => {
                  let nuevosInsumosGuardados = valueEI.insumosGuardados
                    .map((valueIG) => {
                      const insumoBuscar = this.insumosPorId.get(
                        valueIG.insumoId.toString(),
                      );
                      return {
                        ...valueIG,
                        familiaNombre: insumoBuscar?.familia?.nombre,
                        familiaId: insumoBuscar?.familiaId,
                      };
                    })
                    .sort((a, b) => {
                      // Primero ordenamos por familia
                      let familiaCompare;

                      if (a.familiaNombre && b.familiaNombre) {
                        familiaCompare = a.familiaNombre.localeCompare(
                          b.familiaNombre,
                        );
                      } else if (a.familiaNombre) {
                        familiaCompare = -1;
                      } else if (b.familiaNombre) {
                        familiaCompare = 1;
                      } else {
                        familiaCompare = 0;
                      }
                      if (familiaCompare !== 0) return familiaCompare;
                      // Si las familias son iguales, ordenamos por nombre
                      return a.descripcion.localeCompare(b.descripcion);
                    });

                  let familiaAnteriorId;
                  let familiaAnteriorNombre;

                  return (
                    <TabPane
                      tab={
                        <span>
                          {valueEI.autorizado ? (
                            <CheckOutlined style={{ color: "#52c41a" }} />
                          ) : (
                            <ExclamationOutlined style={{ color: "#faad14" }} />
                          )}
                          {"Explosion " + (indexEI + 1)}
                        </span>
                      }
                      tabKey={valueEI._id}
                      key={valueEI._id}
                    >
                      <Row>
                        <Col span={24}>
                          <TreeSelectItem
                            showSearch
                            style={{
                              width: "100%",
                            }}
                            dropdownStyle={{
                              maxHeight: 400,
                              overflow: "auto",
                            }}
                            multiple
                            placeholder="Seleccionar"
                            allowClear
                            treeDefaultExpandAll
                            disabled
                            value={valueEI.valueExplosion}
                            treeData={partidasArbolHistorial}
                            fieldNames={{ value: "key" }}
                          />
                        </Col>
                      </Row>
                      <table className="table">
                        {valueEI.insumosGuardados.length > 0 ? (
                          <thead>
                            <tr>
                              <th
                                className="th-border"
                                style={{ width: "30%" }}
                              >
                                Insumo
                              </th>
                              <th
                                className="th-border"
                                style={{ width: "20%" }}
                              >
                                Unidad
                              </th>
                              <th
                                className="th-border"
                                style={{ width: "10%" }}
                              >
                                Explosion
                              </th>
                              <th
                                className="th-border"
                                style={{ width: "10%" }}
                              >
                                Pedido
                              </th>
                              <th
                                className="th-border"
                                style={{ width: "15%" }}
                              >
                                Costo
                              </th>
                              <th
                                className="th-border"
                                style={{ width: "15%" }}
                              >
                                Costo Final
                              </th>
                            </tr>
                          </thead>
                        ) : null}
                        {nuevosInsumosGuardados.map((valueInsumo, index) => {
                          const mostrarFamilia =
                            valueInsumo.familiaId !== familiaAnteriorId ||
                            index === 0;
                          familiaAnteriorId = valueInsumo.familiaId;
                          familiaAnteriorNombre = valueInsumo.familiaNombre;

                          return (
                            <tbody key={index}>
                              {mostrarFamilia ? (
                                <tr>
                                  <td
                                    colSpan="6"
                                    style={{
                                      textAlign: "left",
                                      fontWeight: "bold",
                                      fontSize: 20,
                                    }}
                                  >
                                    {familiaAnteriorNombre
                                      ? familiaAnteriorNombre
                                      : "Sin Familia"}
                                  </td>
                                </tr>
                              ) : null}
                              <tr>
                                <td
                                  className="td-border"
                                  style={{
                                    textAlign: "left",
                                    wordBreak: "keep-all",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  <p style={{ margin: 5 }}>
                                    {valueInsumo.descripcion}
                                  </p>
                                </td>
                                <td
                                  className="td-border"
                                  style={{ textAlign: "center" }}
                                >
                                  <p style={{ margin: 5 }}>
                                    {valueInsumo.unidadNombre}
                                  </p>
                                </td>
                                <td
                                  className="td-border"
                                  style={{ textAlign: "right" }}
                                >
                                  <p style={{ margin: 5 }}>
                                    {round4Decimals(valueInsumo.cantidad)}
                                  </p>
                                </td>
                                <td
                                  className="td-border"
                                  style={{ textAlign: "right" }}
                                >
                                  <p style={{ margin: 5 }}>
                                    {round4Decimals(
                                      valueInsumo.cantidadExplosion,
                                    )}
                                  </p>
                                </td>
                                <td
                                  className="td-border"
                                  style={{ textAlign: "right" }}
                                >
                                  <p style={{ margin: 5 }}>
                                    {dineroDisabledMask(valueInsumo.costo || 0)}
                                  </p>
                                </td>
                                <td
                                  className="td-border"
                                  style={{ textAlign: "right" }}
                                >
                                  <p style={{ margin: 5 }}>
                                    {dineroDisabledMask(
                                      valueInsumo.costoFinal || 0,
                                    )}
                                  </p>
                                </td>
                              </tr>
                            </tbody>
                          );
                        })}

                        <tbody key="T">
                          <tr>
                            <td
                              className="td-border"
                              style={{ textAlign: "left" }}
                            >
                              <p style={{ margin: 5 }}>Total:</p>
                            </td>
                            <td
                              className="td-border"
                              style={{ textAlign: "center" }}
                            >
                              <p style={{ margin: 5 }}></p>
                            </td>
                            <td
                              className="td-border"
                              style={{ textAlign: "center" }}
                            >
                              <p style={{ margin: 5 }}></p>
                            </td>
                            <td
                              className="td-border"
                              style={{ textAlign: "center" }}
                            >
                              <p style={{ margin: 5 }}></p>
                            </td>
                            <td
                              className="td-border"
                              style={{ textAlign: "right" }}
                            >
                              <p style={{ margin: 5 }}>
                                {dineroDisabledMask(valueEI.costoTotal || 0)}
                              </p>
                            </td>
                            <td
                              className="td-border"
                              style={{ textAlign: "right" }}
                            >
                              <p style={{ margin: 5 }}>
                                {dineroDisabledMask(
                                  valueEI.costoFinalTotal || 0,
                                )}
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      {!valueEI.autorizado ? (
                        <Popconfirm
                          title="Quieres autorizar esta explosion y requierir los insumos?"
                          onConfirm={() => this.autorizarExplosion(valueEI._id)}
                          okText="Si"
                          cancelText="No"
                          getPopupContainer={(trigger) => trigger.parentElement}
                        >
                          <ButtonItem
                            verde
                            icon={<CheckOutlined />}
                            style={{
                              display: "block",
                              margin: "10px 0px 10px auto",
                            }}
                          >
                            Autorizar
                          </ButtonItem>
                        </Popconfirm>
                      ) : null}
                    </TabPane>
                  );
                })
              : null;

          this.setState({
            objectExplosiones,
            producciones: res.data.producciones || [],
            historialCargado: true,
            loadingHistorial: false,
          });
        } else {
          MensajeError({ message: "Error no se encontro el historial del presupuesto" });
          this.setState({ loadingHistorial: false });
        }
      });
  }

  // Arma el treeData de solo lectura del historial
  construirArbolHistorial(partidas) {
    const mapPartida = (partida) => {
      const children = partida.children ? partida.children.map(mapPartida) : [];

      let title = "";

      if (partida.tipo === 0) {
        title =
          "P : " +
          partida.nombre +
          " " +
          dineroDisabledMask(partida.costoTotal);
      } else if (partida.tipo === 1 && partida.nombre) {
        const matriz = this.matricesPorId.get(partida.nombre?.toString());
        title =
          "M : " +
          matriz.descripcion +
          " " +
          dineroDisabledMask(partida.costoTotal);
      } else {
        title = partida.nombre + " " + dineroDisabledMask(partida.costoTotal);
      }

      return { ...partida, children, title };
    };

    return partidas ? partidas.map(mapPartida) : [];
  }

  // Resuelve matrices/insumos acotado a las partidas en memoria
  async consultarPPresupuesto() {
    await axios
      .post(
        "presupuestosPU/resolverCatalogoMatricesInsumos",
        { empresaId: this.props.empresaId, partidas: this.state.partidas },
        {
          headers: this.props.headersToken,
        },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.matricesPorId = new Map(
            res.data.matrices.map((value) => [value._id.toString(), value]),
          );
          this.insumosPorId = new Map(
            res.data.insumos.map((value) => [value._id.toString(), value]),
          );
          this.setState({
            todasMatrices: res.data.matrices,
            todasInsumos: res.data.insumos,
          });
        }
      });
  }

  autorizarExplosion(id) {
    axios
      .post(
        "presupuestosPU/autorizarExplosion",
        {
          presupuestoId: this.state.id,
          explosionId: id,
          empresaId: this.props.empresaId,
        },
        {
          headers: {
            ...this.props.headersToken,
          },
        },
      )
      .then(async (res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha autorizado la explosion");
          await this.consultarTodo();
          this.setState({ historialCargado: false }, () => this.cargarHistorialPresupuesto());
        } else if (res.data.success === 1) {
          MensajeError({ message: "No se puede autorizar la explosion" });
        } else {
          MensajeError({ message: "Hubo un error y el la explosion no se autorizo" });
        }
      });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  validarPartidaYMatrices() {
    const piezas = this.state.partidas || [];
    if (piezas.length === 0) {
      MensajeError({ message: "Agrega al menos una pieza al presupuesto" });
      return false;
    }

    const erroresPartidas = {};
    const mensajesError = [];

    piezas.forEach((partida, rootIndex) => {
      const nombrePieza = partida?.nombre || `Pieza ${rootIndex + 1}`;

      if (!partida || !partida.nombre || !partida.cantidad || partida.cantidad === 0) {
        mensajesError.push(`${nombrePieza}: falta el nombre o la cantidad de la pieza`);
        return;
      }

      const matrices = partida.children || [];
      if (matrices.length === 0) {
        mensajesError.push(`${nombrePieza}: agrega al menos una matriz`);
        return;
      }

      matrices.forEach((matriz, indexM) => {
        const camposFaltantes = [];
        if (!matriz.nombre) camposFaltantes.push("nombre");
        if (!matriz.cantidad || matriz.cantidad === 0) camposFaltantes.push("cantidad");

        if (camposFaltantes.length > 0) {
          erroresPartidas[matriz.key] = camposFaltantes;
          mensajesError.push(`${nombrePieza} - Matriz ${indexM + 1}: falta ${camposFaltantes.join(", ")}`);
        }
      });
    });

    this.setState({ erroresPartidas });
    if (mensajesError.length > 0) {
      MensajeError({
        message: "Revisa las piezas/matrices marcadas",
        description: mensajesError.join("\n"),
      });
      return false;
    }
    return true;
  }

  onFinish(values) {
    if (!this.validarPartidaYMatrices()) return;
    this.setState({ loading: true });
    if (this.state.id) {
      axios
        .post(
          "presupuestosPU/editarPresupuesto",
          {
            ...values,
            partidas: this.state.partidas,
            presupuestoId: this.state.id,
            empresaId: this.props.empresaId,
          },
          {
            headers: {
              ...this.props.headersToken,
            },
          },
        )
        .then((res) => {
          this.setState({ loading: false, id: res.data.presupuestoId });
          if (res.data.success === 2) {
            message.success("Se ha editado un presupuesto");
            this.consultarTodo();
          } else if (res.data.success === 1) {
            MensajeError({
              message: res.data.message || "No se puede editar el presupuesto",
            });
          } else {
            MensajeError({ message: "Hubo un error y el presupuesto no se edito" });
          }
        });
    } else {
      axios
        .post(
          "presupuestosPU/agregarPresupuesto",
          {
            ...values,
            partidas: this.state.partidas,
            presupuestoId: this.state.id,
            empresaId: this.props.empresaId,
          },
          {
            headers: {
              ...this.props.headersToken,
            },
          },
        )
        .then((res) => {
          this.setState({ loading: false, id: res.data.presupuestoId });
          if (res.data.success === 2) {
            message.success("Se ha agregado un presupuesto");
            this.consultarTodo();
          } else if (res.data.success === 1) {
            MensajeError({ message: "No se puede agregar el presupuesto" });
          } else {
            MensajeError({ message: "Hubo un error y el presupuesto no se agrego" });
          }
        });
    }
  }

  sumarUnoACadaNumero(cadena) {
    return cadena
      .split("-") // Separa por guiones
      .map((num) => String(parseInt(num) + 1)) // Convierte a número, suma 1 y lo convierte de nuevo a string
      .join("-"); // Vuelve a unir con guiones
  }

  async consultarInventariosDobles(insumosExplosionados) {
    const proyectoGeneralId = this.formRef.current.getFieldValue("proyectoId");
    const proyectoProduccionId = this.formRef.current.getFieldValue("proyectoProduccionId");

    const [resGeneral, resProduccion] = await Promise.all([
      axios.post(
        "inventarios/inventarioInsumosProyecto",
        { proyectoId: proyectoGeneralId, insumos: insumosExplosionados, empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      ),
      axios.post(
        "inventarios/inventarioInsumosProyecto",
        { proyectoId: proyectoProduccionId, insumos: insumosExplosionados, empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      ),
    ]);

    const inventarioProduccionPorId = new Map(
      (resProduccion.data.insumos || []).map((valueI) => [
        valueI.insumoId.toString(),
        valueI.cantidadProyecto,
      ]),
    );

    return (resGeneral.data.insumos || []).map((valueI) => ({
      ...valueI,
      cantidadProyectoGeneral: valueI.cantidadProyecto,
      cantidadProyectoProduccion: inventarioProduccionPorId.get(valueI.insumoId.toString()) || 0,
    }));
  }

  async explosionInsumos() {
    await this.setState({ loadingExplosion: true });
    const partidas = [...this.state.partidas];

    let insumosExplosionados = [];

    let costoTotalIE = 0;

    const processInsumo = (insumo, cantidadTotal) => {
      const insumoBuscar = this.state.todasInsumos.find(
        (valueTI) => valueTI._id.toString() === insumo.insumoId.toString(),
      );
      //Matriz sobre matriz
      if (insumoBuscar?.matriz) {
        (insumo.children || []).forEach((valueIU) => {
          processInsumo(
            valueIU,
            cantidadTotal *
              (valueIU.calculo ? valueIU.cantidad / 100 : valueIU.cantidad),
          );
        });
      } else {
        if (insumoBuscar) {
          const indexIE = insumosExplosionados.findIndex(
            (valueTIE) =>
              valueTIE.insumoId.toString() === insumo.insumoId.toString(),
          );
          const costo = insumo.calculo
            ? round2Decimals(insumo.costo * cantidadTotal)
            : insumoBuscar.costo
              ? insumoBuscar.costo
              : insumo.costo;
          const costoTotal = round2Decimals(
            (insumoBuscar.costo ? insumoBuscar.costo : insumo.costo) *
              cantidadTotal,
          );
          const cantidadPedida = round10Decimals(insumo.cantidadPedida || 0);

          if (indexIE === -1) {
            insumosExplosionados.push({
              insumoId: insumo.insumoId,
              nombre: insumoBuscar.descripcion,
              descripcionInsumo: insumoBuscar.descripcion,
              unidad: insumoBuscar.unidad.nombre,
              familiaId: insumoBuscar.familiaId,
              familiaNombre: insumoBuscar?.familia?.nombre,
              costo,
              catidadMinCompra: insumoBuscar?.catidadMinCompra,
              costoTotal,
              cantidadPedida,
              cantidad: insumo.calculo ? 1 : cantidadTotal,
            });
          } else {
            insumosExplosionados[indexIE].cantidad = insumo.calculo
              ? 1
              : round10Decimals(
                  insumosExplosionados[indexIE].cantidad + cantidadTotal,
                );
            insumosExplosionados[indexIE].costo = insumo.calculo
              ? round2Decimals(insumosExplosionados[indexIE].costo + costo)
              : insumosExplosionados[indexIE].costo;
            insumosExplosionados[indexIE].costoTotal = round2Decimals(
              insumosExplosionados[indexIE].costoTotal + costoTotal,
            );
            insumosExplosionados[indexIE].cantidadPedida = insumo.calculo
              ? Math.max(
                  insumosExplosionados[indexIE].cantidadPedida,
                  cantidadPedida,
                )
              : round10Decimals(
                  insumosExplosionados[indexIE].cantidadPedida + cantidadPedida,
                );
          }
          costoTotalIE += costoTotal;
        } else {
          // Si no se encuentra el insumo, se puede manejar el error o la lógica correspondiente
          MensajeError({
            message: "Insumo no encontrado",
            description:
              (insumo.nombre ? insumo.nombre : "") +
              " en " +
              this.sumarUnoACadaNumero(insumo.key),
          });
        }
      }
    };

    const traversePartidas = (partidas, keys = [], cantidadAcumulada = 1) => {
      for (const [index, partida] of partidas.entries()) {
        if (partida.children) {
          traversePartidas(
            partida.children,
            [...keys, index],
            cantidadAcumulada * partida.cantidad,
          );
        }

        if (partida.tipo === 1 && partida.nombre && partida.children) {
          for (const insumo of partida.children) {
            const cantidadTotal =
              cantidadAcumulada *
              partida.cantidad *
              (insumo.calculo ? insumo.cantidad / 100 : insumo.cantidad);
            processInsumo(insumo, round10Decimals(cantidadTotal));
          }
        }
      }
    };

    if (partidas) {
      traversePartidas(partidas);
    }

    const partidasArbol = partidas
      ? partidas.map((valueP1) => {
          const mapPartidas = (partida, nivel = 1) => {
            let nuevasPartidas;

            if (partida.children) {
              nuevasPartidas = partida.children.map((child) =>
                mapPartidas(child, nivel + 1),
              );
            }

            let title = "";

            if (partida.tipo === 0) {
              title =
                "P : " +
                partida.nombre +
                " " +
                dineroDisabledMask(partida.costoTotal);
            } else if (partida.tipo === 1 && partida.nombre) {
              const matriz = this.state.todasMatrices.find(
                (valueM) =>
                  valueM._id.toString() === partida?.nombre?.toString(),
              );
              title =
                "M : " +
                matriz.descripcion +
                " " +
                dineroDisabledMask(partida.costoTotal);
            } else {
              title =
                partida.nombre + " " + dineroDisabledMask(partida.costoTotal);
            }

            return { ...partida, children: nuevasPartidas, title };
          };

          return mapPartidas(valueP1);
        })
      : [];

    let nuevosInsumosExplosionados = await this.consultarInventariosDobles(insumosExplosionados);

    nuevosInsumosExplosionados.sort((a, b) => {
      // Primero ordenamos por familia
      let familiaCompare;

      if (a.familiaNombre && b.familiaNombre) {
        familiaCompare = a.familiaNombre.localeCompare(b.familiaNombre);
      } else if (a.familiaNombre) {
        familiaCompare = -1;
      } else if (b.familiaNombre) {
        familiaCompare = 1;
      } else {
        familiaCompare = 0;
      }
      if (familiaCompare !== 0) return familiaCompare;
      // Si las familias son iguales, ordenamos por nombre
      return a.descripcionInsumo.localeCompare(b.descripcionInsumo);
    });

    await this.setState({
      loadingExplosion: false,
      insumosExplosionados: nuevosInsumosExplosionados,
      costoTotalIE,
      partidasArbol,
    });

    this.cambioPedir();
  }

  async onChangeExplosion(valuesKeys, consultar) {
    let newFielsValue = {};
    for (const insumoExplosion of this.state.insumosExplosionados) {
      newFielsValue["pedir" + insumoExplosion.insumoId] = undefined;
    }

    this.formRef.current.setFieldsValue(newFielsValue);

    if (!consultar) return this.setState({ valueExplosion: valuesKeys });

    if (valuesKeys.length === 0) {
      this.explosionInsumos();
      await this.setState({ valueExplosion: valuesKeys });
    } else {
      await this.setState({ loadingExplosion: true });
      const partidas = [...this.state.partidas];

      let insumosExplosionados = [];

      let costoTotalIE = 0;

      const processInsumo = (insumo, cantidadTotal) => {
        const insumoBuscar = this.state.todasInsumos.find(
          (valueTI) => valueTI._id.toString() === insumo.insumoId.toString(),
        );
        //Matriz sobre matriz
        if (insumoBuscar?.matriz) {
          (insumo.children || []).forEach((valueIU) => {
            processInsumo(
              valueIU,
              cantidadTotal *
                (valueIU.calculo ? valueIU.cantidad / 100 : valueIU.cantidad),
            );
          });
        } else {
          if (insumoBuscar) {
            const indexIE = insumosExplosionados.findIndex(
              (valueTIE) =>
                valueTIE.insumoId.toString() === insumo.insumoId.toString(),
            );
            const costo = insumo.calculo
              ? round2Decimals(insumo.costo * cantidadTotal)
              : insumoBuscar.costo
                ? insumoBuscar.costo
                : insumo.costo;
            const costoTotal = round2Decimals(
              (insumoBuscar.costo ? insumoBuscar.costo : insumo.costo) *
                cantidadTotal,
            );
            const cantidadPedida = round10Decimals(insumo.cantidadPedida || 0);

            if (indexIE === -1) {
              insumosExplosionados.push({
                insumoId: insumo.insumoId,
                nombre: insumoBuscar.descripcion,
                descripcionInsumo: insumoBuscar.descripcion,
                unidad: insumoBuscar.unidad.nombre,
                familiaId: insumoBuscar.familiaId,
                familiaNombre: insumoBuscar?.familia?.nombre,
                costo,
                catidadMinCompra: insumoBuscar?.catidadMinCompra,
                costoTotal,
                cantidadPedida,
                cantidad: insumo.calculo ? 1 : cantidadTotal,
              });
            } else {
              insumosExplosionados[indexIE].cantidad = insumo.calculo
                ? 1
                : round10Decimals(
                    insumosExplosionados[indexIE].cantidad + cantidadTotal,
                  );
              insumosExplosionados[indexIE].costo = insumo.calculo
                ? round2Decimals(insumosExplosionados[indexIE].costo + costo)
                : insumosExplosionados[indexIE].costo;
              insumosExplosionados[indexIE].costoTotal = round2Decimals(
                insumosExplosionados[indexIE].costoTotal + costoTotal,
              );
              insumosExplosionados[indexIE].cantidadPedida = insumo.calculo
                ? Math.max(
                    insumosExplosionados[indexIE].cantidadPedida,
                    cantidadPedida,
                  )
                : round10Decimals(
                    insumosExplosionados[indexIE].cantidadPedida +
                      cantidadPedida,
                  );
            }

            costoTotalIE += costoTotal;
          } else {
            // Si no se encuentra el insumo, se puede manejar el error o la lógica correspondiente
            MensajeError({
              message: "Insumo no encontrado",
              description:
                (insumo.nombre ? insumo.nombre : "") +
                " en " +
                this.sumarUnoACadaNumero(insumo.key),
            });
          }
        }
      };

      const traversePartidas = (
        partidas,
        keys = [],
        cantidadAcumulada = 1,
        keyExplosionAnterior,
      ) => {
        for (const [index, partida] of partidas.entries()) {
          const key = [...keys, index].join("-");
          const keyExplosion = valuesKeys.includes(key) || keyExplosionAnterior;

          if (partida.tipo === 0 && partida.children) {
            traversePartidas(
              partida.children,
              [...keys, index],
              cantidadAcumulada * partida.cantidad,
              keyExplosion,
            );
          }

          if (partida.tipo === 1 && partida.nombre && partida.children) {
            for (const [indexMatriz, insumo] of partida.children.entries()) {
              const cantidadTotal =
                cantidadAcumulada *
                partida.cantidad *
                (insumo.calculo ? insumo.cantidad / 100 : insumo.cantidad);
              const keyMatriz = [...keys, index, indexMatriz].join("-");
              const keyMatrizExplosion = valuesKeys.includes(keyMatriz);
              if (
                keyExplosion ||
                keyMatrizExplosion ||
                keys.some((k) => valuesKeys.includes(k))
              ) {
                processInsumo(insumo, round10Decimals(cantidadTotal));
              }
            }
          }
        }
      };

      if (partidas) {
        traversePartidas(partidas);
      }

      let nuevosInsumosExplosionados = await this.consultarInventariosDobles(insumosExplosionados);

      nuevosInsumosExplosionados.sort((a, b) => {
        let familiaCompare;

        if (a.familiaNombre && b.familiaNombre) {
          familiaCompare = a.familiaNombre.localeCompare(b.familiaNombre);
        } else if (a.familiaNombre) {
          familiaCompare = -1;
        } else if (b.familiaNombre) {
          familiaCompare = 1;
        } else {
          familiaCompare = 0;
        }
        if (familiaCompare !== 0) return familiaCompare;
        // Si las familias son iguales, ordenamos por nombre
        return a.descripcionInsumo.localeCompare(b.descripcionInsumo);
      });

      await this.setState({
        loadingExplosion: false,
        insumosExplosionados: nuevosInsumosExplosionados,
        costoTotalIE,
        valueExplosion: valuesKeys,
      });
      this.cambioPedir();
    }
  }

  async confirmarPresupuesto() {
    if (!this.validarPartidaYMatrices()) return;
    this.formRef.current
      .validateFields()
      .then((values) => {
        this.setState({ loading: true });
        axios
          .post(
            "presupuestosPU/confirmarPresupuesto",
            {
              ...values,
              partidas: this.state.partidas,
              presupuestoId: this.state.id,
              empresaId: this.props.empresaId,
            },
            {
              headers: {
                ...this.props.headersToken,
              },
            },
          )
          .then((res) => {
            this.setState({ loading: false });
            if (res.data.success === 2) {
              this.setState({ id: res.data.presupuestoId });
              message.success("Se ha confirmado el presupuesto");
              this.consultarTodo();
            } else if (res.data.success === 1) {
              MensajeError({
                message: res.data.message || "No se puede confirmar el presupuesto",
              });
            } else {
              MensajeError({ message: "Hubo un error y el presupuesto no se confirmo" });
            }
          });
      })
      .catch((e) => this.onFinishFailed(e));
  }

  autorizarPresupuesto() {
    if (!this.validarPartidaYMatrices()) return;
    this.setState({ loading: true });
    axios
      .post(
        "presupuestosPU/autorizarPresupuesto",
        { presupuestoId: this.state.id },
        {
          headers: this.props.headersToken,
        },
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Presupuesto autorizado correctamente");
          this.consultarTodo();
        } else {
          MensajeError({
            message: res.data.message || "No se pudo autorizar el presupuesto",
          });
        }
      });
  }

  nuevaVersionPresupuesto() {
    this.setState({ loading: true });
    axios
      .post(
        "presupuestosPU/clonarPresupuesto",
        { presupuestoId: this.state.id },
        {
          headers: this.props.headersToken,
        },
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            res.data.message || "Presupuesto clonado correctamente",
          );
          this.props.history.replace("/panel/presupuestoPU", {
            id: res.data.presupuestoId,
          });
          this.setState({ id: res.data.presupuestoId }, () =>
            this.consultarTodo(),
          );
        } else {
          MensajeError({
            message: res.data.message || "No se pudo crear la nueva versión",
          });
        }
      });
  }

  irAGenerarOrdenDeProduccion(record) {
    this.props.history.push("/panel/ordenDeProduccionPU", {
      presupuestoPUId: this.state.id,
      partidaPath: (record.key || "").split("-").map(Number),
      piezaId: record.piezaId,
      proyectoGeneralId: this.formRef.current.getFieldValue("proyectoId"),
      proyectoProduccionId: this.formRef.current.getFieldValue("proyectoProduccionId"),
    });
  }

  agregarMatriz(rootIndex) {
    const partidas = [...this.state.partidas];
    const children = partidas[rootIndex].children || [];

    children.push({
      tipo: 1,
      nombre: undefined,
      etapaId: undefined,
      unidad: "",
      cantidad: 1,
      costo: 0,
      costoTotal: 0,
      costoCImpuestos: 0,
      costoTotalCImpuestos: 0,
      key: rootIndex + "-" + children.length,
    });
    partidas[rootIndex] = { ...partidas[rootIndex], children };

    let expandedRowKeys = [...this.state.expandedRowKeys, rootIndex + "-" + (children.length - 1)];

    const nuevasPartidas = this.calcularPresupuesto(partidas);
    this.setState({ partidas: nuevasPartidas, expandedRowKeys });
  }

  onChangeNombrePartida(value, rootIndex) {
    const partidas = [...this.state.partidas];
    partidas[rootIndex] = { ...partidas[rootIndex], nombre: value.target.value };
    this.setState({ partidas });
  }

  onChangeUnidadPartida(value, rootIndex) {
    const partidas = [...this.state.partidas];
    partidas[rootIndex] = { ...partidas[rootIndex], unidad: value };
    this.setState({ partidas });
  }

  onChangeCantidadPartida(value, rootIndex) {
    const partidas = [...this.state.partidas];
    partidas[rootIndex] = { ...partidas[rootIndex], cantidad: value.target.value };
    const nuevasPartidas = this.calcularPresupuesto(partidas);
    this.setState({ partidas: nuevasPartidas });
  }

  onChangeTiempoCicloPartida(value, rootIndex) {
    const capturado = value?.target?.value;
    const minutos =
      capturado === "" || capturado === null || capturado === undefined
        ? undefined
        : unidadAMinutos(Number(capturado) || 0, this.props.unidadTiempoProduccion);
    const partidas = [...this.state.partidas];
    const anterior = partidas[rootIndex]?.tiempoCiclo;
    if ((anterior || 0) === (minutos || 0)) return;
    partidas[rootIndex] = { ...partidas[rootIndex], tiempoCiclo: minutos };
    this.setState({ partidas });

    if (!this.state.id) return;
    axios
      .post(
        "presupuestosPU/actualizarTiempoCicloPieza",
        {
          empresaId: this.props.empresaId,
          presupuestoId: this.state.id,
          piezaId: partidas[rootIndex]?.piezaId,
          rootIndex,
          tiempoCiclo: minutos || 0,
        },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Tiempo ciclo de la pieza guardado");
        } else {
          MensajeError({ message: res.data.message || "No se pudo guardar el tiempo ciclo de la pieza" });
        }
      })
      .catch(() => MensajeError({ message: "Error al conectar con el servidor" }));
  }

  tiempoCicloDeMatriz(matriz) {
    const total = (matriz?.produccionEtapas || []).reduce((acc, etapa) => acc + (Number(etapa.tiempoCiclo) || 0), 0);
    return total > 0 ? round2Decimals(total) : undefined;
  }

  filaFinalDePieza(partida) {
    const filas = partida?.children || [];
    if (filas.length !== 1 || filas[0].tipo !== 1 || !filas[0].nombre || !partida.matrizBaseId) return null;
    if (filas[0].nombre.toString() !== partida.matrizBaseId.toString()) return null;
    const matriz = this.matricesPorId.get(filas[0].nombre.toString());
    return matriz?.tipoMatriz === 2 ? filas[0] : null;
  }

  filasDePieza(partida) {
    const filaFinal = this.filaFinalDePieza(partida);
    if (!filaFinal) return partida?.children || [];
    const cantidadFinal = Number(filaFinal.cantidadTotal) || Number(partida.cantidad) || 0;
    return (filaFinal.children || []).map((fila) => ({
      ...fila,
      cantidadTotal: round4Decimals((fila.calculo ? fila.cantidad / 100 : fila.cantidad) * cantidadFinal),
    }));
  }

  tiempoCicloPorDefecto(partida) {
    const matriz = this.state.matrizBasePorPieza[partida.piezaId] || (partida.matrizBaseId && this.matricesPorId.get(partida.matrizBaseId.toString()));
    return this.tiempoCicloDeMatriz(matriz);
  }

  onChangeObservacionesPartida(value, rootIndex) {
    const observaciones = value?.target?.value ?? "";
    const partidas = [...this.state.partidas];
    if ((partidas[rootIndex]?.observaciones || "") === observaciones) return;
    partidas[rootIndex] = { ...partidas[rootIndex], observaciones };
    this.setState({ partidas });

    if (!this.state.id) return;
    axios
      .post(
        "presupuestosPU/actualizarObservacionesPieza",
        {
          empresaId: this.props.empresaId,
          presupuestoId: this.state.id,
          piezaId: partidas[rootIndex]?.piezaId,
          rootIndex,
          observaciones,
        },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Observaciones de la pieza guardadas");
        } else {
          MensajeError({ message: res.data.message || "No se pudieron guardar las observaciones de la pieza" });
        }
      })
      .catch(() => MensajeError({ message: "Error al conectar con el servidor" }));
  }

  calcularPresupuesto(partidas) {
    const calcularCostoYCantidad = (partida, keys = [], parentCantidad = 1) => {
      let costo =
        partida.children && partida?.children?.length > 0 ? 0 : partida.costo;
      let costoCImpuestos =
        partida.children && partida?.children?.length > 0
          ? 0
          : partida.costoCImpuestos || 0;
      let cantidadTotal = partida.calculo
        ? partida.cantidad / 100
        : partida.cantidad;

      if (partida.children) {
        const newChildren = partida.children.map((child, index) => {
          const childKeys = [...keys, index];
          const result = calcularCostoYCantidad(
            child,
            childKeys,
            parentCantidad * cantidadTotal,
          );
          costo += round2Decimals(
            result.costo *
              (child.calculo ? child.cantidad / 100 : child.cantidad),
          );
          costoCImpuestos += round2Decimals(
            result.costoCImpuestos *
              (child.calculo ? child.cantidad / 100 : child.cantidad),
          );
          return result;
        });

        cantidadTotal = round10Decimals(parentCantidad * cantidadTotal);
        return {
          ...partida,
          key: keys.join("-"),
          costo,
          costoTotal: round2Decimals(
            costo *
              (partida.calculo ? partida.cantidad / 100 : partida.cantidad),
          ),
          costoCImpuestos,
          costoTotalCImpuestos: round2Decimals(
            costoCImpuestos *
              (partida.calculo ? partida.cantidad / 100 : partida.cantidad),
          ),
          children: newChildren,
          cantidadTotal,
        };
      }

      return {
        ...partida,
        key: keys.join("-"),
        costo,
        costoTotal: round2Decimals(
          costo * (partida.calculo ? partida.cantidad / 100 : partida.cantidad),
        ),
        costoCImpuestos,
        costoTotalCImpuestos: round2Decimals(
          costoCImpuestos *
            (partida.calculo ? partida.cantidad / 100 : partida.cantidad),
        ),
        cantidadTotal: round10Decimals(parentCantidad * cantidadTotal),
      };
    };

    const nuevasPartidas = partidas
      ? partidas.map((partida, index) =>
          calcularCostoYCantidad(partida, [index]),
        )
      : [];

    return nuevasPartidas;
  }

  // Normaliza y mergea la matriz elegida en matricesPorId/insumosPorId
  onSeleccionarMatriz(value, matrizElegida, key) {
    if (!matrizElegida) {
      this.onChangeMatrizId(value, key);
      return;
    }

    const matrizNormalizada = {
      ...matrizElegida,
      unidad:
        typeof matrizElegida.unidad === "string"
          ? { nombre: matrizElegida.unidad }
          : matrizElegida.unidad,
    };
    delete matrizNormalizada.insumosUtilizarResuelto;

    this.matricesPorId.set(matrizNormalizada._id.toString(), matrizNormalizada);

    const registrarInsumosResueltos = (insumosUtilizarResuelto) => {
      for (const valueHijo of insumosUtilizarResuelto || []) {
        if (valueHijo.insumo) {
          this.insumosPorId.set(
            valueHijo.insumo._id.toString(),
            valueHijo.insumo,
          );
          if (valueHijo.insumo.matriz) {
            registrarInsumosResueltos(valueHijo.insumo.insumosUtilizarResuelto);
          }
        }
      }
    };
    registrarInsumosResueltos(matrizElegida.insumosUtilizarResuelto);

    this.setState(
      {
        todasMatrices: [...this.matricesPorId.values()],
        todasInsumos: [...this.insumosPorId.values()],
      },
      () => {
        this.onChangeMatrizId(value, key);
      },
    );
  }

  aplicarMatrizBaseAPieza(matrizBaseId, matrizBaseElegida, rootIndex) {
    const piezaId = this.state.partidas[rootIndex]?.piezaId;

    if (!matrizBaseElegida) {
      const matrizBasePorPieza = { ...this.state.matrizBasePorPieza };
      delete matrizBasePorPieza[piezaId];
      const partidas = [...this.state.partidas];
      partidas[rootIndex] = { ...partidas[rootIndex], matrizBaseId: undefined };
      this.setState({ matrizBasePorPieza, partidas });
      return;
    }

    const matrizNormalizada = {
      ...matrizBaseElegida,
      unidad:
        typeof matrizBaseElegida.unidad === "string"
          ? { nombre: matrizBaseElegida.unidad }
          : matrizBaseElegida.unidad,
    };
    delete matrizNormalizada.insumosUtilizarResuelto;

    const continuarConReemplazo = () => {
      this.matricesPorId.set(matrizNormalizada._id.toString(), matrizNormalizada);

      const registrarInsumosResueltos = (insumosUtilizarResuelto) => {
        for (const valueHijo of insumosUtilizarResuelto || []) {
          if (valueHijo.insumo) {
            this.insumosPorId.set(valueHijo.insumo._id.toString(), valueHijo.insumo);
            if (valueHijo.insumo.matriz) {
              this.matricesPorId.set(valueHijo.insumo._id.toString(), valueHijo.insumo);
              registrarInsumosResueltos(valueHijo.insumo.insumosUtilizarResuelto);
            }
          }
        }
      };
      registrarInsumosResueltos(matrizBaseElegida.insumosUtilizarResuelto);

      this.setState(
        {
          todasMatrices: [...this.matricesPorId.values()],
          todasInsumos: [...this.insumosPorId.values()],
          matrizBasePorPieza: { ...this.state.matrizBasePorPieza, [piezaId]: matrizNormalizada },
        },
        () => this.llenarPiezaDesdeMatrizBase(matrizNormalizada, rootIndex),
      );
    };

    const piezaTieneMatrices = (this.state.partidas[rootIndex]?.children || []).length > 0;
    if (piezaTieneMatrices) {
      Modal.confirm({
        title: "¿Reemplazar las matrices de esta pieza?",
        content: "Esta pieza ya tiene matrices capturadas. Al aplicar la matriz base se reemplazan por completo.",
        okText: "Reemplazar",
        cancelText: "Cancelar",
        onOk: continuarConReemplazo,
      });
    } else {
      continuarConReemplazo();
    }
  }

  llenarPiezaDesdeMatrizBase(matrizBase, rootIndex) {
    const esFinal = matrizBase.tipoMatriz === 2;
    const subMatrices = esFinal
      ? [{ insumoId: matrizBase._id, cantidad: 1 }]
      : (matrizBase.insumosUtilizar || []).filter((item) => {
          const insumoBuscar = this.state.todasInsumos.find(
            (valueTI) => valueTI._id.toString() === item.insumoId.toString(),
          );
          return !!insumoBuscar?.matriz;
        });

    const children = subMatrices
      .map((item, index) =>
        this.construirFilaMatrizDesdeBase(item.insumoId, item.cantidad, rootIndex + "-" + index),
      )
      .filter(Boolean);

    const partidas = [...this.state.partidas];
    partidas[rootIndex] = {
      ...partidas[rootIndex],
      nombre: matrizBase.descripcion,
      matrizBaseId: matrizBase._id,
      unidad: matrizBase.unidad?.nombre || "",
      tiempoCiclo: this.tiempoCicloDeMatriz(matrizBase) ?? partidas[rootIndex]?.tiempoCiclo,
      children,
    };

    this.setState({ partidas: this.calcularPresupuesto(partidas) });

    if (subMatrices.length === 0) {
      MensajeError({
        message: "Esta matriz no tiene sub-matrices",
        description:
          "Se llenaron el nombre y la unidad de la pieza con los de esta matriz, pero no tiene otras matrices dentro de sus insumos; agrega las matrices manualmente.",
      });
    }
  }

  construirFilaMatrizDesdeBase(matrizId, cantidad, key) {
    const datos = this.resolverDatosMatriz(matrizId, key);
    if (!datos) return null;

    return {
      tipo: 1,
      nombre: matrizId,
      etapaId: undefined,
      unidad: datos.unidad,
      cantidad,
      costo: datos.costo,
      costoTotal: round2Decimals(datos.costo * cantidad),
      costoCImpuestos: 0,
      costoTotalCImpuestos: 0,
      children: datos.children,
      key,
    };
  }

  resolverHijoMatriz(valueMatriz, indexMatriz, keyPadre, acumuladorCosto) {
    const key = keyPadre + "-" + indexMatriz;
    const insumoBuscar = this.state.todasInsumos.find(
      (valueTI) => valueTI._id.toString() === valueMatriz.insumoId.toString(),
    );

    if (!insumoBuscar) {
      MensajeError({
        message: "Insumo no encontrado",
        description:
          "Un insumo de esta matriz (" + valueMatriz.insumoId + ") no se pudo resolver.",
      });
      return {
        insumoMatriz: true,
        nombre: "Insumo no encontrado",
        unidad: undefined,
        children: undefined,
        costoTotal: 0,
        costo: 0,
        costoTotalCImpuestos: 0,
        costoCImpuestos: 0,
        cantidad: valueMatriz.cantidad,
        insumoId: valueMatriz.insumoId,
        key,
      };
    }

    const costoTotal = round10Decimals(
      (insumoBuscar.costo ? insumoBuscar.costo : valueMatriz.costo) *
        (insumoBuscar.calculo ? valueMatriz.cantidad / 100 : valueMatriz.cantidad),
    );
    acumuladorCosto.total += costoTotal;

    let costoCImpuestos;

    if (!insumoBuscar.matriz) {
      let totalImpuestos = 0;

      if (insumoBuscar.impuestos && insumoBuscar.impuestos.length > 0) {
        for (const valueImpuesto of insumoBuscar.impuestos) {
          let totalImpuesto;
          if (valueImpuesto.tasaCuota === 1) {
            totalImpuesto = round6Decimals(insumoBuscar.costo * (valueImpuesto.monto / 100));
          } else if (valueImpuesto.tasaCuota === 2) {
            totalImpuesto = round6Decimals(
              (insumoBuscar.costo + totalImpuestos) * (valueImpuesto.monto / 100),
            );
          } else if (valueImpuesto.tasaCuota === 3) {
            totalImpuesto = round6Decimals(valueMatriz.cantidad * valueImpuesto.monto);
          } else if (valueImpuesto.tasaCuota === 4) {
            totalImpuesto = 0;
          } else if (valueImpuesto.tasaCuota === 5) {
            totalImpuesto = 0;
          }

          totalImpuestos += totalImpuesto;
        }
      }

      costoCImpuestos = round2Decimals(
        (insumoBuscar.costo ? insumoBuscar.costo : valueMatriz.costo) + totalImpuestos,
      );
    } else {
      costoCImpuestos = insumoBuscar.costo ? insumoBuscar.costo : valueMatriz.costo;
    }

    return {
      insumoMatriz: true,
      calculo: insumoBuscar.calculo,
      nombre: insumoBuscar?.descripcion,
      unidad: insumoBuscar?.unidad?.nombre,
      children:
        insumoBuscar.matriz && insumoBuscar.insumosUtilizar
          ? insumoBuscar.insumosUtilizar.map((valueHijo, indexHijo) =>
              this.resolverHijoMatriz(valueHijo, indexHijo, key, acumuladorCosto),
            )
          : undefined,
      costoTotal,
      costo: insumoBuscar.costo ? insumoBuscar.costo : valueMatriz.costo,
      costoTotalCImpuestos: round2Decimals(
        costoCImpuestos * (insumoBuscar.calculo ? valueMatriz.cantidad / 100 : valueMatriz.cantidad),
      ),
      costoCImpuestos,
      cantidad: valueMatriz.cantidad,
      insumoId: valueMatriz.insumoId,
      key,
    };
  }

  resolverDatosMatriz(matrizId, key) {
    const matriz = this.state.todasMatrices.find(
      (valueM) => valueM._id.toString() === matrizId.toString(),
    );
    if (!matriz) return null;

    const acumuladorCosto = { total: 0 };
    const children = matriz.insumosUtilizar.map((valueMatriz, indexMatriz) =>
      this.resolverHijoMatriz(valueMatriz, indexMatriz, key, acumuladorCosto),
    );

    return { children, costo: acumuladorCosto.total, unidad: matriz.unidad.nombre };
  }

  onChangeMatrizId(value, key) {
    const partidas = [...this.state.partidas];

    const arrayKeys = key.split("-").map((valueKey) => Number(valueKey));

    let childrenMatriz = [];
    let costoMatriz = 0;
    let unidad = "";

    if (value) {
      const datos = this.resolverDatosMatriz(value, key);

      // Matriz no encontrada en el catálogo acotado: degrada con aviso
      if (!datos) {
        MensajeError({
          message: "Matriz no encontrada",
          description:
            "No se pudo cargar la información de la matriz seleccionada. Intenta de nuevo.",
        });
        return;
      }

      childrenMatriz = datos.children;
      costoMatriz = datos.costo;
      unidad = datos.unidad;
    }

    const matrizActual = partidas[arrayKeys[0]].children[arrayKeys[1]];
    matrizActual.nombre = value;
    matrizActual.children = childrenMatriz;
    matrizActual.costo = costoMatriz;
    matrizActual.unidad = unidad;
    matrizActual.costoTotal = round2Decimals(costoMatriz * (matrizActual.cantidad || 0));

    const nuevasPartidas = this.calcularPresupuesto(partidas);

    this.setState({ partidas: nuevasPartidas });
    if (value) this.quitarErrorPartida(key, "nombre");
  }

  quitarErrorPartida(key, campo) {
    if (!this.state.erroresPartidas[key]?.includes(campo)) return;
    const erroresPartidas = { ...this.state.erroresPartidas };
    const restantes = erroresPartidas[key].filter((c) => c !== campo);
    if (restantes.length > 0) {
      erroresPartidas[key] = restantes;
    } else {
      delete erroresPartidas[key];
    }
    this.setState({ erroresPartidas });
  }

  onChangeCantidad(value, key) {
    const partidas = [...this.state.partidas];
    const arrayKeys = key.split("-").map((valueKey) => Number(valueKey));
    partidas[arrayKeys[0]].children[arrayKeys[1]].cantidad = value.target.value;

    const nuevasPartidas = this.calcularPresupuesto(partidas);

    this.setState({ partidas: nuevasPartidas });
    if (value.target.value) this.quitarErrorPartida(key, "cantidad");
  }

  campoConError(key, campo) {
    return !!this.state.erroresPartidas[key]?.includes(campo);
  }

  // Class property (no .bind en cada render) para no romper la memoización de la tabla de Partidas.
  Cell = (props) => {
    if (props?.dataIndex === "nombre" && !props.record.insumoMatriz) {
      const matrizActual = props.record.nombre
        ? this.matricesPorId.get(props.record.nombre.toString())
        : null;
      const conError = this.campoConError(props.record.key, "nombre");
      return (
        <td {...props} style={{ ...props.style, padding: 0, boxShadow: conError ? "inset 0 0 0 1px #ff4d4f" : undefined }}>
          <SelectInsumosItem
            sinBorde
            style={{
              backgroundColor: "transparent",
            }}
            placeholder="Matriz"
            width="100%"
            tiposInsumos="matrices"
            empresaId={this.props.empresaId}
            headersToken={this.props.headersToken}
            value={props.record.nombre}
            insumoPreCargado={matrizActual}
            onChange={(value, matrizElegida) => {
              this.onSeleccionarMatriz(
                value,
                matrizElegida,
                props.record.key,
              );
            }}
          />
        </td>
      );
    } else if (props?.dataIndex === "cantidad" && !props.record.insumoMatriz) {
      const conError = this.campoConError(props.record.key, "cantidad");
      return (
        <td
          {...props}
          className={`${props.className || ""} celda-cantidad-pu`}
          style={{ ...props.style, padding: "0 4px", boxShadow: conError ? "inset 0 0 0 1px #ff4d4f" : undefined }}
        >
          <InputNumberItem
            sinBorde
            style={{
              backgroundColor: "transparent",
            }}
            placeholder="Cantidad"
            defaultValue={props.record.cantidad}
            onBlur={(value) => {
              this.onChangeCantidad(value, props.record.key);
            }}
          />
        </td>
      );
    } else {
      return <td {...props} />;
    }
  };

  quitarMatriz(rootIndex, index) {
    const partidas = [...this.state.partidas];
    partidas[rootIndex] = {
      ...partidas[rootIndex],
      children: (partidas[rootIndex].children || []).filter((_, i) => i !== index),
    };

    const nuevasPartidas = this.calcularPresupuesto(partidas);

    this.setState({ partidas: nuevasPartidas });
  }

  piezaTieneOrdenGenerada(piezaId, rootIndex) {
    return (this.state.ordenesProduccionPresupuesto || []).some((orden) =>
      orden.piezaId ? orden.piezaId === piezaId : orden.partidaPath?.[0] === rootIndex,
    );
  }

  eliminarPieza(rootIndex) {
    const partidas = this.state.partidas.filter((_, i) => i !== rootIndex);
    const nuevasPartidas = this.calcularPresupuesto(partidas);
    this.setState({ partidas: nuevasPartidas });
  }

  onExpandedRowsChange(value) {
    this.setState({ expandedRowKeys: value });
  }

  requerirInsumos() {
    this.formRef.current
      .validateFields()
      .then((values) => {
        this.setState({ loading: true });
        axios
          .post(
            "presupuestosPU/requerirInsumos",
            {
              ...values,
              valueExplosion: this.state.valueExplosion,
              presupuestoId: this.state.id,
              empresaId: this.props.empresaId,
            },
            {
              headers: {
                ...this.props.headersToken,
              },
            },
          )
          .then(async (res) => {
            if (res.data.success === 2) {
              if (res.data.numeroRequisicion) {
                message.success(
                  "Se ha generado la requisicion numero: " +
                    res.data.numeroRequisicion,
                );
              } else {
                message.success("Se ha generado la explosion por autorizar");
              }
              await this.consultarTodo();
              await this.onChangeExplosion(this.state.valueExplosion);
              this.setState({ loading: false });
            } else if (res.data.success === 1) {
              MensajeError({ message: res.data.message });
              this.setState({ loading: false });
            } else {
              MensajeError({ message: "Hubo un error y la requisicion no se genero" });
              this.setState({ loading: false });
            }
          });
      })
      .catch((err) => {
        message.info(
          "Esta explosion de insumos se guardara para una autorizacion posterior",
        );

        if (err.errorFields && err.errorFields?.length > 0) {
          for (const error of err.errorFields) {
            if (error.errors && error.errors?.length > 0) {
              for (const errorFinal of error.errors) {
                if (errorFinal === "El maximo es 0") {
                  return message.info(
                    "Si la cantidad maxima es 0 ya no puede pedir mas",
                  );
                }
              }
            }
          }
        }

        axios
          .post(
            "presupuestosPU/requerirInsumos",
            {
              ...err.values,
              valueExplosion: this.state.valueExplosion,
              sobresaleCantidades: true,
              presupuestoId: this.state.id,
              empresaId: this.props.empresaId,
            },
            {
              headers: {
                ...this.props.headersToken,
              },
            },
          )
          .then(async (res) => {
            if (res.data.success === 2) {
              message.success("Se ha guardado la explosion de insumos");
              await this.consultarTodo();
              await this.onChangeExplosion(this.state.valueExplosion);
              this.setState({ loading: false });
            } else if (res.data.success === 1) {
              MensajeError({ message: res.data.message });
              this.setState({ loading: false });
            } else {
              MensajeError({ message: "Hubo un error y la requisicion no se genero" });
              this.setState({ loading: false });
            }
          });
      });
  }

  pedirTotales() {
    let newFielsValue = {};
    for (const insumoExplosion of this.state.insumosExplosionados) {
      newFielsValue["pedir" + insumoExplosion.insumoId] =
        insumoExplosion.cantidad - insumoExplosion.cantidadPedida > 0
          ? round4Decimals(
              insumoExplosion.cantidad - insumoExplosion.cantidadPedida,
            )
          : 0;
    }

    this.cambioPedir();

    this.formRef.current.setFieldsValue(newFielsValue);
  }

  async cambioPedir() {
    await this.setState({ loadingExplosion: true });

    let totalCostoPedir = 0;

    const nuevosInsumosExplosionados = await Promise.all(
      this.state.insumosExplosionados.map(async (valueIE) => {
        const pedir = await this.formRef.current.getFieldValue(
          "pedir" + valueIE.insumoId,
        );

        totalCostoPedir = round2Decimals(
          totalCostoPedir + valueIE.costo * (pedir || 0),
        );

        return {
          ...valueIE,
          costoPedir: round2Decimals(valueIE.costo * (pedir || 0)),
        };
      }),
    );

    await this.setState({
      loadingExplosion: false,
      insumosExplosionados: nuevosInsumosExplosionados,
      totalCostoPedir,
    });
  }

  async pedirMinCompraTotales() {
    let newFielsValue = {};
    for (const insumoExplosion of this.state.insumosExplosionados) {
      let cantidadPedir = round10Decimals(
        insumoExplosion.cantidad - insumoExplosion.cantidadPedida,
      );

      if (insumoExplosion.catidadMinCompra) {
        const residuo = round10Decimals(
          cantidadPedir % insumoExplosion.catidadMinCompra,
        );
        if (residuo !== 0) {
          const divisionEntera = Math.floor(
            cantidadPedir / insumoExplosion.catidadMinCompra,
          );

          cantidadPedir =
            (divisionEntera + 1) * insumoExplosion.catidadMinCompra > 0
              ? round10Decimals(
                  (divisionEntera + 1) * insumoExplosion.catidadMinCompra,
                )
              : 0;
        }
      }

      newFielsValue["pedir" + insumoExplosion.insumoId] =
        round4Decimals(cantidadPedir);
    }

    this.cambioPedir();

    this.formRef.current.setFieldsValue(newFielsValue);
  }

  pedirTotalesFamilia(familiaId) {
    let newFielsValue = {};
    for (const insumoExplosion of this.state.insumosExplosionados) {
      if (insumoExplosion.familiaId.toString() === familiaId.toString()) {
        newFielsValue["pedir" + insumoExplosion.insumoId] =
          insumoExplosion.cantidad - insumoExplosion.cantidadPedida > 0
            ? round4Decimals(
                insumoExplosion.cantidad - insumoExplosion.cantidadPedida,
              )
            : 0;
      }
    }

    this.cambioPedir();

    this.formRef.current.setFieldsValue(newFielsValue);
  }

  async pedirMinCompraTotalesFamilia(familiaId) {
    let newFielsValue = {};
    for (const insumoExplosion of this.state.insumosExplosionados) {
      if (insumoExplosion.familiaId.toString() === familiaId.toString()) {
        let cantidadPedir = round10Decimals(
          insumoExplosion.cantidad - insumoExplosion.cantidadPedida,
        );

        if (insumoExplosion.catidadMinCompra) {
          const residuo = round10Decimals(
            cantidadPedir % insumoExplosion.catidadMinCompra,
          );
          if (residuo !== 0) {
            const divisionEntera = Math.floor(
              cantidadPedir / insumoExplosion.catidadMinCompra,
            );

            cantidadPedir =
              (divisionEntera + 1) * insumoExplosion.catidadMinCompra > 0
                ? round10Decimals(
                    (divisionEntera + 1) * insumoExplosion.catidadMinCompra,
                  )
                : 0;
          }
        }

        newFielsValue["pedir" + insumoExplosion.insumoId] =
          round4Decimals(cantidadPedir);
      }
    }

    this.cambioPedir();

    this.formRef.current.setFieldsValue(newFielsValue);
  }
  descargarMatrices(tipo) {
    this.setState({ loadingReportes: true });

    const calcularConImpuestos = this.formRef.current.getFieldValue(
      "calcularConImpuestos",
    );
    const calcularConIndirectos = this.formRef.current.getFieldValue(
      "calcularConIndirectos",
    );
    const indirectos = this.formRef.current.getFieldValue("indirectos");
    const nombre = this.formRef.current.getFieldValue("nombre");
    const fechaInicio = this.formRef.current.getFieldValue("fechaInicio");
    const fechaFinal = this.formRef.current.getFieldValue("fechaFinal");

    if (tipo === "pdf") {
      let lineasMatricesPdf = [];

      const partidas = [...this.state.partidas];

      const processMatriz = (
        matriz,
        cantidadTotal,
        nombrePartida,
        partidaKey,
      ) => {
        const insumosAgrupadosTipoInsumo = [];

        let agregarCalculosFinales = [];

        const matrizCostoDirecto = calcularConImpuestos
          ? matriz.costoCImpuestos
          : matriz.costo;

        let matrizCostoTotal = calcularConImpuestos
          ? matriz.costoCImpuestos
          : matriz.costo;

        let agregarPdfM = [];

        const matrizBuscar = this.state.todasMatrices.find(
          (valueTM) => valueTM._id.toString() === matriz.nombre.toString(),
        );

        //Indirectos

        if (calcularConIndirectos && indirectos && indirectos.length > 0) {
          for (const indirecto of indirectos) {
            let costoIndirecto = 0;

            if (indirecto.calculo === 1) {
              //Sobre Total

              costoIndirecto =
                matrizCostoDirecto * (indirecto.porcentaje / 100);
            } else if (indirecto.calculo === 2) {
              //Sobre Acumulado

              costoIndirecto = matrizCostoTotal * (indirecto.porcentaje / 100);
            }

            matrizCostoTotal = round2Decimals(
              matrizCostoTotal + costoIndirecto,
            );

            agregarCalculosFinales.push([
              { text: "", style: "textoTabla", alignment: "center" },
              {
                text: "(CI) " + indirecto.nombre,
                style: "textoTabla",
                alignment: "left",
              },
              { text: "", style: "textoTabla", alignment: "center" },
              { text: "", style: "textoTabla", alignment: "center" },
              { text: "", style: "textoTabla", alignment: "center" },
              {
                text: indirecto.porcentaje + "%",
                style: "textoTabla",
                alignment: "right",
              },
              {
                text: dineroDisabledMask(costoIndirecto),
                style: "textoTabla",
                alignment: "right",
              },
              { text: "", style: "textoTabla", alignment: "center" },
            ]);
          }
        }

        for (const insumo of matriz.children) {
          const insumoBuscar = this.state.todasInsumos.find(
            (valueTI) => valueTI._id.toString() === insumo.insumoId.toString(),
          );

          if (insumoBuscar.matriz) {
            const insumosMatriz2 = insumo.children.map((valueIM) => {
              const insumoBuscar2 = this.state.todasInsumos.find(
                (valueTI) =>
                  valueTI._id.toString() === valueIM.insumoId.toString(),
              );

              return {
                ...valueIM,
                ...insumoBuscar2,
              };
            });

            insumosAgrupadosTipoInsumo.push({
              tipoDeInsumoId: insumoBuscar._id.toString(),
              matriz2: true,
              nombre: insumo.nombre,
              costoTotal: round2Decimals(insumo.costoTotal),
              costoTotalCImpuestos: round2Decimals(insumo.costoTotalCImpuestos),
              unidad: insumo.unidad,
              cantidad: insumo.cantidad,
              insumos: insumosMatriz2,
            });
          } else {
            const indexInsumosAgrupadosTipoInsumo =
              insumosAgrupadosTipoInsumo.findIndex(
                (valueIATI) =>
                  valueIATI?.tipoDeInsumoId?.toString() ===
                  insumoBuscar?.tipoDeInsumoId?.toString(),
              );

            if (indexInsumosAgrupadosTipoInsumo === -1) {
              let tipoDeInsumo;

              if (insumoBuscar.tipoDeInsumoId) {
                tipoDeInsumo = this.state.tipoInsumos.find(
                  (valueTTI) =>
                    valueTTI._id.toString() ===
                    insumoBuscar.tipoDeInsumoId.toString(),
                );
              }

              insumosAgrupadosTipoInsumo.push({
                tipoDeInsumoId: insumoBuscar.tipoDeInsumoId,
                nombre: tipoDeInsumo?.nombre,
                insumos: [{ ...insumo, ...insumoBuscar }],
              });
            } else {
              insumosAgrupadosTipoInsumo[
                indexInsumosAgrupadosTipoInsumo
              ].insumos.push({ ...insumo, ...insumoBuscar });
            }
          }
        }

        agregarPdfM.push(
          [
            { text: "Partida:", style: "textoTabla", alignment: "left" },
            { text: nombrePartida, style: "textoTabla", alignment: "left" },
            {
              text: "Análisis No.:",
              style: "textoTablaBold",
              alignment: "center",
            },
            { text: "", style: "textoTabla", alignment: "center" },
            {
              text: cantidadTotal,
              style: "textoTablaBold",
              alignment: "center",
            },
            { text: "", style: "textoTabla", alignment: "right" },
            { text: "", style: "textoTabla", alignment: "right" },
            { text: "", style: "textoTabla", alignment: "center" },
          ],
          [
            { text: "Análisis:", style: "textoTablaBold", alignment: "left" },
            { text: "", style: "textoTabla", alignment: "left" },
            { text: "", style: "textoTablaBold", alignment: "center" },
            {
              text: matriz.unidad,
              style: "textoTablaBold",
              alignment: "center",
            },
            { text: "", style: "textoTablaBold", alignment: "center" },
            {
              text: matriz.cantidad,
              style: "textoTablaBold",
              alignment: "right",
            },
            {
              text: dineroDisabledMask(matrizCostoTotal * matriz.cantidad),
              style: "textoTablaBold",
              alignment: "right",
            },
            { text: "", style: "textoTablaBold", alignment: "center" },
          ],
          [
            {
              text: matrizBuscar.descripcion,
              colSpan: 8,
              style: "textoTabla",
              alignment: {
                horizontal: "left",
                wrapText: true,
                vertical: "top",
              },
            },
            {},
            {},
            {},
            {},
            {},
            {},
            {},
          ],
        );

        for (const insumoAgrupadoTipoInsumo of insumosAgrupadosTipoInsumo) {
          agregarPdfM.push([
            {
              text: insumoAgrupadoTipoInsumo.nombre
                ? insumoAgrupadoTipoInsumo.nombre
                : "MATERIALES",
              colSpan: 5,
              style: "textoTablaBold",
              alignment: "left",
            },
            {},
            {},
            {},
            {},
            { text: "", style: "textoTablaBold", alignment: "center" },
            { text: "", style: "textoTablaBold", alignment: "center" },
            { text: "", style: "textoTablaBold", alignment: "center" },
          ]);

          const costoTotalCOpciones = calcularConImpuestos
            ? insumoAgrupadoTipoInsumo.costoTotalCImpuestos
            : insumoAgrupadoTipoInsumo.costoTotal;

          let sumaPorcentajes = insumoAgrupadoTipoInsumo.matriz2
            ? round2Decimals((costoTotalCOpciones / matrizCostoDirecto) * 100)
            : 0;
          let sumaImportes = insumoAgrupadoTipoInsumo.matriz2
            ? round2Decimals(costoTotalCOpciones)
            : 0;
          let sumaImportesInsumos = 0;

          for (const insumo of insumoAgrupadoTipoInsumo.insumos) {
            const costoTotalInsumo = calcularConImpuestos
              ? insumo.costoTotalCImpuestos
              : insumo.costoTotal;

            agregarPdfM.push([
              {
                text: insumo.clave ? insumo.clave : "",
                style: "textoTabla",
                alignment: "center",
              },
              { text: insumo.nombre, style: "textoTabla", alignment: "left" },
              {
                text: insumo.unidad.nombre,
                style: "textoTabla",
                alignment: "center",
              },
              {
                text: dineroDisabledMask(insumo.costo),
                style: "textoTabla",
                alignment: "right",
              },
              { text: "*", style: "textoTabla", alignment: "center" },
              {
                text: insumo.cantidad,
                style: "textoTabla",
                alignment: "right",
              },
              {
                text: dineroDisabledMask(costoTotalInsumo),
                style: "textoTabla",
                alignment: "right",
              },
              {
                text: insumoAgrupadoTipoInsumo.matriz2
                  ? "0.00%"
                  : round2Decimals(
                      (costoTotalInsumo / matrizCostoDirecto) * 100,
                    ) + "%",
                style: "textoTabla",
                alignment: "right",
              },
            ]);

            if (!insumoAgrupadoTipoInsumo.matriz2) {
              sumaImportes = sumaImportes + round2Decimals(costoTotalInsumo);
              sumaPorcentajes =
                sumaPorcentajes +
                round2Decimals((costoTotalInsumo / matrizCostoDirecto) * 100);
            } else {
              sumaImportesInsumos =
                sumaImportesInsumos + round2Decimals(costoTotalInsumo);
            }
          }

          if (insumoAgrupadoTipoInsumo.matriz2) {
            agregarPdfM.push([
              { text: "", style: "textoTabla", alignment: "center" },
              { text: "Importe:", style: "textoTabla", alignment: "left" },
              { text: "", style: "textoTabla", alignment: "center" },
              { text: "", style: "textoTabla", alignment: "right" },
              { text: "", style: "textoTabla", alignment: "center" },
              { text: "", style: "textoTabla", alignment: "right" },
              {
                text: dineroDisabledMask(sumaImportesInsumos),
                style: "textoTabla",
                alignment: "right",
              },
              { text: "", style: "textoTabla", alignment: "right" },
            ]);

            agregarPdfM.push([
              { text: "", style: "textoTabla", alignment: "center" },
              {
                text: "Rendimiento: " + insumoAgrupadoTipoInsumo.unidad,
                style: "textoTabla",
                alignment: "left",
              },
              { text: "", style: "textoTabla", alignment: "center" },
              { text: "", style: "textoTabla", alignment: "right" },
              { text: "", style: "textoTabla", alignment: "center" },
              {
                text: insumoAgrupadoTipoInsumo.cantidad,
                style: "textoTabla",
                alignment: "right",
              },
              {
                text: dineroDisabledMask(sumaImportes),
                style: "textoTabla",
                alignment: "right",
              },
              {
                text: round2Decimals(sumaPorcentajes) + "%",
                style: "textoTabla",
                alignment: "right",
              },
            ]);
          }

          agregarPdfM.push([
            { text: "" },
            { text: "" },
            { text: "" },
            { text: "" },
            { text: "" },
            { text: "" },
            { text: "" },
            { text: "" },
          ]);

          agregarPdfM.push([
            { text: "", style: "textoTabla", alignment: "center" },
            { text: "SUBTOTAL:", style: "textoTablaBold", alignment: "left" },
            {
              text: insumoAgrupadoTipoInsumo.nombre
                ? insumoAgrupadoTipoInsumo.nombre
                : "MATERIALES",
              colSpan: 4,
              style: "textoTablaBold",
              alignment: "left",
            },
            {},
            {},
            {},
            {
              text: dineroDisabledMask(sumaImportes),
              style: "textoTablaBold",
              alignment: "right",
            },
            {
              text: round2Decimals(sumaPorcentajes) + "%",
              style: "textoTablaBold",
              alignment: "right",
            },
          ]);
        }

        //Lineas de la matriz final

        //Costo directo

        agregarPdfM.push([
          { text: "", style: "textoTabla", alignment: "center" },
          {
            text: "(CD) Costo directo",
            style: "textoTablaBold",
            alignment: "left",
          },
          { text: "", style: "textoTabla", alignment: "center" },
          { text: "", style: "textoTabla", alignment: "center" },
          { text: "", style: "textoTabla", alignment: "center" },
          { text: "", style: "textoTabla", alignment: "center" },
          {
            text: dineroDisabledMask(matrizCostoDirecto),
            style: "textoTablaBold",
            alignment: "right",
          },
          { text: "100%", style: "textoTablaBold", alignment: "right" },
        ]);

        //Agregar Costos indirectos

        for (const calculoFinal of agregarCalculosFinales) {
          agregarPdfM.push(calculoFinal);
        }

        agregarPdfM.push([
          { text: "", style: "textoTabla", alignment: "center" },
          {
            text: "PRECIO UNITARIO (CD+CI)",
            style: "textoTabla",
            alignment: "left",
          },
          { text: "", style: "textoTabla", alignment: "center" },
          { text: "", style: "textoTabla", alignment: "center" },
          { text: "", style: "textoTabla", alignment: "center" },
          { text: "", style: "textoTabla", alignment: "center" },
          {
            text: dineroDisabledMask(matrizCostoTotal),
            style: "textoTabla",
            alignment: "right",
          },
          { text: "", style: "textoTabla", alignment: "right" },
        ]);

        //Linea en blanco

        agregarPdfM.push([
          { text: "" },
          { text: "" },
          { text: "" },
          { text: "" },
          { text: "" },
          { text: "" },
          { text: "" },
          { text: "" },
        ]);

        lineasMatricesPdf = [...lineasMatricesPdf, ...agregarPdfM];
      };

      const traversePartidas = (
        partidas,
        keys = [],
        cantidadAcumulada = 1,
        partidaNombre = "",
      ) => {
        for (const [index, partida] of partidas.entries()) {
          if (partida.children && partida.tipo !== 1) {
            traversePartidas(
              partida.children,
              [...keys, index],
              cantidadAcumulada * partida.cantidad,
              partida.nombre,
            );
          }

          if (partida.tipo === 1 && partida.nombre && partida.children) {
            processMatriz(
              partida,
              round10Decimals(cantidadAcumulada),
              partidaNombre,
              keys.join("-"),
            );
          }
        }
      };

      if (partidas) {
        traversePartidas(partidas);
      }

      axios
        .post(
          "presupuestosPU/selectDatosParaPdf",
          { empresaId: this.props.empresaId },
          {
            headers: this.props.headersToken,
          },
        )
        .then((res) => {
          if (res.data.success === 2) {
            const pdf = reporteMatricesPdf({
              fechaFinal,
              fechaInicio,
              matrices: lineasMatricesPdf,
              nombrePresupuesto: nombre,
              empresa: res.data.empresa,
              logoBiwo: res.data.logoBiwo,
            });

            pdfMake
              .createPdf(pdf)
              .download(`MATRICES ${nombre ? nombre : ""}.pdf`);

            this.setState({ loadingReportes: false });
          } else {
            MensajeError({ message: "No se pudo descargar el reporte" });
          }
        });
    } else if (tipo === "excel") {
      let mergesHoja = [];

      let rowsHoja = [];

      const allBorders = {
        top: { style: "thin", color: { auto: 1 } },
        bottom: { style: "thin", color: { auto: 1 } },
        left: { style: "thin", color: { auto: 1 } },
        right: { style: "thin", color: { auto: 1 } },
      };

      const topBorder = {
        top: { style: "thin", color: { auto: 1 } },
      };

      // const noBorders = {
      //     top: { style: 'none' },
      //     bottom: { style: 'none' },
      //     left: { style: 'none' },
      //     right: { style: 'none' },
      // };

      let lineasDescargarHoja = [];

      //Encabezado

      lineasDescargarHoja.push([]);

      lineasDescargarHoja.push([
        {
          v: "ANALISIS DE PRECIOS UNITARIOS",
          t: "s",
          s: {
            font: { bold: true, sz: 14 },
            alignment: { horizontal: "center" },
          },
        },
        {
          v: "",
          t: "s",
          s: { font: { bold: true }, alignment: { horizontal: "center" } },
        },
        {
          v: "",
          t: "s",
          s: { font: { bold: true }, alignment: { horizontal: "center" } },
        },
        {
          v: "",
          t: "s",
          s: { font: { bold: true }, alignment: { horizontal: "center" } },
        },
        {
          v: "",
          t: "s",
          s: { font: { bold: true }, alignment: { horizontal: "center" } },
        },
        {
          v: "",
          t: "s",
          s: { font: { bold: true }, alignment: { horizontal: "center" } },
        },
        {
          v: "",
          t: "s",
          s: { font: { bold: true }, alignment: { horizontal: "center" } },
        },
        {
          v: "",
          t: "s",
          s: { font: { bold: true }, alignment: { horizontal: "center" } },
        },
      ]);

      mergesHoja.push(XLSXStyle.utils.decode_range("A2:H2"));

      lineasDescargarHoja.push([]);

      lineasDescargarHoja.push([
        {
          v: "Código",
          t: "s",
          s: {
            font: { bold: true },
            alignment: { horizontal: "center" },
            border: allBorders,
          },
        },
        {
          v: "Concepto",
          t: "s",
          s: {
            font: { bold: true },
            alignment: { horizontal: "center" },
            border: allBorders,
          },
        },
        {
          v: "Unidad",
          t: "s",
          s: {
            font: { bold: true },
            alignment: { horizontal: "center" },
            border: allBorders,
          },
        },
        {
          v: "P. Unitario",
          t: "s",
          s: {
            font: { bold: true },
            alignment: { horizontal: "center" },
            border: allBorders,
          },
        },
        {
          v: "Op.",
          t: "s",
          s: {
            font: { bold: true },
            alignment: { horizontal: "center" },
            border: allBorders,
          },
        },
        {
          v: "Cantidad",
          t: "s",
          s: {
            font: { bold: true },
            alignment: { horizontal: "center" },
            border: allBorders,
          },
        },
        {
          v: "Importe",
          t: "s",
          s: {
            font: { bold: true },
            alignment: { horizontal: "center" },
            border: allBorders,
          },
        },
        {
          v: "%",
          t: "s",
          s: {
            font: { bold: true },
            alignment: { horizontal: "center" },
            border: allBorders,
          },
        },
      ]);

      const partidas = [...this.state.partidas];

      const processMatriz = (
        matriz,
        cantidadTotal,
        nombrePartida,
        partidaKey,
      ) => {
        const insumosAgrupadosTipoInsumo = [];

        let agregarCalculosFinales = [];

        const matrizCostoDirecto = calcularConImpuestos
          ? matriz.costoCImpuestos
          : matriz.costo;

        let matrizCostoTotal = calcularConImpuestos
          ? matriz.costoCImpuestos
          : matriz.costo;

        let agregarExcelM = [];

        const matrizBuscar = this.state.todasMatrices.find(
          (valueTM) => valueTM._id.toString() === matriz.nombre.toString(),
        );

        //Indirectos

        if (calcularConIndirectos && indirectos && indirectos.length > 0) {
          for (const indirecto of indirectos) {
            let costoIndirecto = 0;

            if (indirecto.calculo === 1) {
              //Sobre Total

              costoIndirecto =
                matrizCostoDirecto * (indirecto.porcentaje / 100);
            } else if (indirecto.calculo === 2) {
              //Sobre Acumulado

              costoIndirecto = matrizCostoTotal * (indirecto.porcentaje / 100);
            }

            matrizCostoTotal = round2Decimals(
              matrizCostoTotal + costoIndirecto,
            );

            agregarCalculosFinales.push([
              {
                v: "",
                t: "s",
                s: {
                  font: { bold: true },
                  alignment: { horizontal: "center" },
                },
              },
              {
                v: "(CI) " + indirecto.nombre,
                t: "s",
                s: { alignment: { horizontal: "left" } },
              },
              {
                v: "",
                t: "s",
                s: {
                  font: { bold: true },
                  alignment: { horizontal: "center" },
                },
              },
              {
                v: "",
                t: "s",
                s: {
                  font: { bold: true },
                  alignment: { horizontal: "center" },
                },
              },
              {
                v: "",
                t: "s",
                s: {
                  font: { bold: true },
                  alignment: { horizontal: "center" },
                },
              },
              {
                v: indirecto.porcentaje + "%",
                t: "s",
                s: { alignment: { horizontal: "right" } },
              },
              {
                v: dineroDisabledMask(costoIndirecto),
                t: "s",
                s: { alignment: { horizontal: "right" } },
              },
              {
                v: "",
                t: "s",
                s: {
                  font: { bold: true },
                  alignment: { horizontal: "center" },
                },
              },
            ]);
          }
        }

        for (const insumo of matriz.children) {
          const insumoBuscar = this.state.todasInsumos.find(
            (valueTI) => valueTI._id.toString() === insumo.insumoId.toString(),
          );

          if (insumoBuscar.matriz) {
            const insumosMatriz2 = insumo.children.map((valueIM) => {
              const insumoBuscar2 = this.state.todasInsumos.find(
                (valueTI) =>
                  valueTI._id.toString() === valueIM.insumoId.toString(),
              );

              return {
                ...valueIM,
                ...insumoBuscar2,
              };
            });

            insumosAgrupadosTipoInsumo.push({
              tipoDeInsumoId: insumoBuscar._id.toString(),
              matriz2: true,
              nombre: insumo.nombre,
              costoTotal: round2Decimals(insumo.costoTotal),
              costoTotalCImpuestos: round2Decimals(insumo.costoTotalCImpuestos),
              unidad: insumo.unidad,
              cantidad: insumo.cantidad,
              insumos: insumosMatriz2,
            });
          } else {
            const indexInsumosAgrupadosTipoInsumo =
              insumosAgrupadosTipoInsumo.findIndex(
                (valueIATI) =>
                  valueIATI?.tipoDeInsumoId?.toString() ===
                  insumoBuscar?.tipoDeInsumoId?.toString(),
              );

            if (indexInsumosAgrupadosTipoInsumo === -1) {
              let tipoDeInsumo;

              if (insumoBuscar.tipoDeInsumoId) {
                tipoDeInsumo = this.state.tipoInsumos.find(
                  (valueTTI) =>
                    valueTTI._id.toString() ===
                    insumoBuscar.tipoDeInsumoId.toString(),
                );
              }

              insumosAgrupadosTipoInsumo.push({
                tipoDeInsumoId: insumoBuscar.tipoDeInsumoId,
                nombre: tipoDeInsumo?.nombre,
                insumos: [{ ...insumo, ...insumoBuscar }],
              });
            } else {
              insumosAgrupadosTipoInsumo[
                indexInsumosAgrupadosTipoInsumo
              ].insumos.push({ ...insumo, ...insumoBuscar });
            }
          }
        }

        agregarExcelM.push(
          [
            { v: "Partida:", t: "s", s: { alignment: { horizontal: "left" } } },
            {
              v: nombrePartida,
              t: "s",
              s: { alignment: { horizontal: "left" } },
            },
            {
              v: "Análisis No.:",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
            {
              v: "",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
            {
              v: cantidadTotal,
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
            {
              v: "",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
            {
              v: "",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
            {
              v: "",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
          ],
          [
            {
              v: "Análisis:",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "left" } },
            },
            { v: "", t: "s", s: { alignment: { horizontal: "left" } } },
            {
              v: "",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
            {
              v: matriz.unidad,
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
            {
              v: "",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
            {
              v: matriz.cantidad,
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "right" } },
            },
            {
              v: dineroDisabledMask(matrizCostoTotal * matriz.cantidad),
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "right" } },
            },
            {
              v: "",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
          ],
          [
            {
              v: matrizBuscar.descripcion,
              t: "s",
              s: {
                alignment: {
                  horizontal: "left",
                  wrapText: true,
                  vertical: "top",
                },
              },
            },
            { v: "", t: "s", s: { alignment: { horizontal: "left" } } },
            {
              v: "",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
            {
              v: "",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
            {
              v: "",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
            {
              v: "",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
            {
              v: "",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
            {
              v: "",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
          ],
        );

        for (const insumoAgrupadoTipoInsumo of insumosAgrupadosTipoInsumo) {
          agregarExcelM.push([
            {
              v: insumoAgrupadoTipoInsumo.nombre
                ? insumoAgrupadoTipoInsumo.nombre
                : "MATERIALES",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "left" } },
            },
            { v: "", t: "s", s: { alignment: { horizontal: "left" } } },
            {
              v: "",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
            {
              v: "",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
            {
              v: "",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
            {
              v: "",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
            {
              v: "",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
            {
              v: "",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
          ]);

          const costoTotalCOpciones = calcularConImpuestos
            ? insumoAgrupadoTipoInsumo.costoTotalCImpuestos
            : insumoAgrupadoTipoInsumo.costoTotal;

          let sumaPorcentajes = insumoAgrupadoTipoInsumo.matriz2
            ? round2Decimals((costoTotalCOpciones / matrizCostoDirecto) * 100)
            : 0;
          let sumaImportes = insumoAgrupadoTipoInsumo.matriz2
            ? round2Decimals(costoTotalCOpciones)
            : 0;
          let sumaImportesInsumos = 0;

          for (const insumo of insumoAgrupadoTipoInsumo.insumos) {
            const costoTotalInsumo = calcularConImpuestos
              ? insumo.costoTotalCImpuestos
              : insumo.costoTotal;

            agregarExcelM.push([
              {
                v: insumo.clave ? insumo.clave : "",
                t: "s",
                s: { alignment: { horizontal: "center" } },
              },
              {
                v: insumo.nombre,
                t: "s",
                s: { alignment: { horizontal: "left" } },
              },
              {
                v: insumo.unidad.nombre,
                t: "s",
                s: { alignment: { horizontal: "center" } },
              },
              {
                v: dineroDisabledMask(insumo.costo),
                t: "s",
                s: { alignment: { horizontal: "right" } },
              },
              { v: "*", t: "s", s: { alignment: { horizontal: "center" } } },
              {
                v: insumo.cantidad,
                t: "s",
                s: { alignment: { horizontal: "right" } },
              },
              {
                v: dineroDisabledMask(costoTotalInsumo),
                t: "s",
                s: { alignment: { horizontal: "right" } },
              },
              {
                v: insumoAgrupadoTipoInsumo.matriz2
                  ? "0.00%"
                  : round2Decimals(
                      (costoTotalInsumo / matrizCostoDirecto) * 100,
                    ) + "%",
                t: "s",
                s: { alignment: { horizontal: "right" } },
              },
            ]);

            if (!insumoAgrupadoTipoInsumo.matriz2) {
              sumaImportes = sumaImportes + round2Decimals(costoTotalInsumo);
              sumaPorcentajes =
                sumaPorcentajes +
                round2Decimals((costoTotalInsumo / matrizCostoDirecto) * 100);
            } else {
              sumaImportesInsumos =
                sumaImportesInsumos + round2Decimals(costoTotalInsumo);
            }
          }

          if (insumoAgrupadoTipoInsumo.matriz2) {
            agregarExcelM.push([
              { v: "", t: "s", s: { alignment: { horizontal: "center" } } },
              {
                v: "Importe:",
                t: "s",
                s: { alignment: { horizontal: "left" } },
              },
              { v: "", t: "s", s: { alignment: { horizontal: "center" } } },
              { v: "", t: "s", s: { alignment: { horizontal: "right" } } },
              { v: "", t: "s", s: { alignment: { horizontal: "center" } } },
              { v: "", t: "s", s: { alignment: { horizontal: "right" } } },
              {
                v: dineroDisabledMask(sumaImportesInsumos),
                t: "s",
                s: { alignment: { horizontal: "right" } },
              },
              { v: "", t: "s", s: { alignment: { horizontal: "right" } } },
            ]);

            agregarExcelM.push([
              { v: "", t: "s", s: { alignment: { horizontal: "center" } } },
              {
                v: "Rendimiento: " + insumoAgrupadoTipoInsumo.unidad,
                t: "s",
                s: { alignment: { horizontal: "left" } },
              },
              { v: "", t: "s", s: { alignment: { horizontal: "center" } } },
              { v: "", t: "s", s: { alignment: { horizontal: "right" } } },
              { v: "", t: "s", s: { alignment: { horizontal: "center" } } },
              {
                v: insumoAgrupadoTipoInsumo.cantidad,
                t: "s",
                s: { alignment: { horizontal: "right" } },
              },
              {
                v: dineroDisabledMask(sumaImportes),
                t: "s",
                s: { alignment: { horizontal: "right" } },
              },
              {
                v: round2Decimals(sumaPorcentajes) + "%",
                t: "s",
                s: { alignment: { horizontal: "right" } },
              },
            ]);
          }

          agregarExcelM.push([]);

          agregarExcelM.push([
            {
              v: "SUBTOTAL:",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "left" } },
            },
            {
              v: insumoAgrupadoTipoInsumo.nombre
                ? insumoAgrupadoTipoInsumo.nombre
                : "MATERIALES",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "left" } },
            },
            {
              v: "",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
            {
              v: "",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
            {
              v: "",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
            {
              v: "",
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "center" } },
            },
            {
              v: dineroDisabledMask(sumaImportes),
              t: "s",
              s: {
                font: { bold: true },
                border: topBorder,
                alignment: { horizontal: "right" },
              },
            },
            {
              v: round2Decimals(sumaPorcentajes) + "%",
              t: "s",
              s: {
                font: { bold: true },
                border: topBorder,
                alignment: { horizontal: "right" },
              },
            },
          ]);
        }

        //Lineas de la matriz final

        //Costo directo

        agregarExcelM.push([
          {
            v: "",
            t: "s",
            s: { font: { bold: true }, alignment: { horizontal: "center" } },
          },
          {
            v: "(CD) Costo directo",
            t: "s",
            s: { font: { bold: true }, alignment: { horizontal: "left" } },
          },
          {
            v: "",
            t: "s",
            s: { font: { bold: true }, alignment: { horizontal: "center" } },
          },
          {
            v: "",
            t: "s",
            s: { font: { bold: true }, alignment: { horizontal: "center" } },
          },
          {
            v: "",
            t: "s",
            s: { font: { bold: true }, alignment: { horizontal: "center" } },
          },
          {
            v: "",
            t: "s",
            s: { font: { bold: true }, alignment: { horizontal: "center" } },
          },
          {
            v: dineroDisabledMask(matrizCostoDirecto),
            t: "s",
            s: {
              font: { bold: true },
              border: topBorder,
              alignment: { horizontal: "right" },
            },
          },
          {
            v: 100 + "%",
            t: "s",
            s: { font: { bold: true }, alignment: { horizontal: "right" } },
          },
        ]);

        //Agregar Costos indirectos

        for (const calculoFinal of agregarCalculosFinales) {
          agregarExcelM.push(calculoFinal);
        }

        agregarExcelM.push([
          {
            v: "",
            t: "s",
            s: { font: { bold: true }, alignment: { horizontal: "center" } },
          },
          {
            v: "PRECIO UNITARIO (CD+CI)",
            t: "s",
            s: { font: { bold: true }, alignment: { horizontal: "left" } },
          },
          {
            v: "",
            t: "s",
            s: { font: { bold: true }, alignment: { horizontal: "center" } },
          },
          {
            v: "",
            t: "s",
            s: { font: { bold: true }, alignment: { horizontal: "center" } },
          },
          {
            v: "",
            t: "s",
            s: { font: { bold: true }, alignment: { horizontal: "center" } },
          },
          {
            v: "",
            t: "s",
            s: { font: { bold: true }, alignment: { horizontal: "center" } },
          },
          {
            v: dineroDisabledMask(matrizCostoTotal),
            t: "s",
            s: { border: topBorder, alignment: { horizontal: "right" } },
          },
          {
            v: "",
            t: "s",
            s: { border: topBorder, alignment: { horizontal: "right" } },
          },
        ]);

        //Linea en blanco

        agregarExcelM.push([]);

        mergesHoja.push(
          XLSXStyle.utils.decode_range(
            "A" +
              (lineasDescargarHoja.length + 3) +
              ":H" +
              (lineasDescargarHoja.length + 3),
          ),
        );

        rowsHoja[lineasDescargarHoja.length + 2] = { hpx: 45 };

        lineasDescargarHoja = [...lineasDescargarHoja, ...agregarExcelM];
      };

      const traversePartidas = (
        partidas,
        keys = [],
        cantidadAcumulada = 1,
        partidaNombre = "",
      ) => {
        for (const [index, partida] of partidas.entries()) {
          if (partida.children && partida.tipo !== 1) {
            traversePartidas(
              partida.children,
              [...keys, index],
              cantidadAcumulada * partida.cantidad,
              partida.nombre,
            );
          }

          if (partida.tipo === 1 && partida.nombre && partida.children) {
            processMatriz(
              partida,
              round10Decimals(cantidadAcumulada),
              partidaNombre,
              keys.join("-"),
            );
          }
        }
      };

      if (partidas) {
        traversePartidas(partidas);
      }

      const worksheetMatrices =
        XLSXStyle.utils.aoa_to_sheet(lineasDescargarHoja);
      worksheetMatrices["!merges"] = mergesHoja;
      worksheetMatrices["!rows"] = rowsHoja;
      worksheetMatrices["!cols"] = [
        { wpx: 70 },
        { wpx: 220 },
        { wpx: 70 },
        { wpx: 100 },
        { wpx: 70 },
        { wpx: 70 },
        { wpx: 100 },
        { wpx: 70 },
      ];
      const workbook = XLSXStyle.utils.book_new();
      XLSXStyle.utils.book_append_sheet(
        workbook,
        worksheetMatrices,
        "Matrices",
      );

      XLSXStyle.writeFile(workbook, `MATRICES ${nombre ? nombre : ""}.xlsx`);
      this.setState({ loadingReportes: false });
    }
  }

  descargarPresupuesto(tipo) {
    this.setState({ loadingReportes: true });

    const calcularConImpuestos = this.formRef.current.getFieldValue(
      "calcularConImpuestos",
    );
    const calcularConIndirectos = this.formRef.current.getFieldValue(
      "calcularConIndirectos",
    );
    const indirectos = this.formRef.current.getFieldValue("indirectos");
    const nombre = this.formRef.current.getFieldValue("nombre");
    const fechaInicio = this.formRef.current.getFieldValue("fechaInicio");
    const fechaFinal = this.formRef.current.getFieldValue("fechaFinal");

    if (tipo === "pdf") {
      let lineasDescargarPdf = [];

      let totalPresupuesto = 0;

      const traversePartidas = (partida, cantidadAcumulada = 1) => {
        if (partida.tipo === 0) {
          lineasDescargarPdf.push([
            { text: "", style: "textoTabla", alignment: "center" },
            {
              text: partida.nombre,
              style: "textoTablaBold",
              alignment: "left",
            },
            { text: "", style: "textoTabla", alignment: "center" },
            { text: "", style: "textoTabla", alignment: "center" },
            { text: "", style: "textoTabla", alignment: "center" },
            { text: "", style: "textoTabla", alignment: "center" },
            { text: "", style: "textoTabla", alignment: "center" },
          ]);
        } else {
          const matrizBuscar = this.state.todasMatrices.find(
            (valueTM) => valueTM._id.toString() === partida.nombre.toString(),
          );

          const cantidadTotal = round10Decimals(
            cantidadAcumulada * partida.cantidad,
          );

          //Indirectos

          let costoMatriz = calcularConImpuestos
            ? partida.costoCImpuestos
            : partida.costo;

          if (calcularConIndirectos && indirectos && indirectos.length > 0) {
            for (const indirecto of indirectos) {
              let costoIndirecto = 0;

              if (indirecto.calculo === 1) {
                //Sobre Total

                costoIndirecto =
                  (calcularConImpuestos
                    ? partida.costoCImpuestos
                    : partida.costo) *
                  (indirecto.porcentaje / 100);
              } else if (indirecto.calculo === 2) {
                //Sobre Acumulado

                costoIndirecto = costoMatriz * (indirecto.porcentaje / 100);
              }

              costoMatriz = round2Decimals(costoMatriz + costoIndirecto);
            }
          }

          lineasDescargarPdf.push([
            {
              text: matrizBuscar.clave ? matrizBuscar.clave : "",
              style: "textoTabla",
              alignment: "center",
            },
            {
              text: matrizBuscar.descripcion,
              style: "textoTabla",
              alignment: "left",
            },
            {
              text: matrizBuscar.unidad.nombre,
              style: "textoTabla",
              alignment: "center",
            },
            { text: cantidadTotal, style: "textoTabla", alignment: "right" },
            {
              text: dineroDisabledMask(costoMatriz),
              style: "textoTabla",
              alignment: "right",
            },
            {
              text: round2Decimals(costoMatriz * cantidadTotal),
              style: "textoTabla",
              alignment: "right",
            },
            { text: "", style: "textoTabla", alignment: "right" },
          ]);

          totalPresupuesto += round2Decimals(costoMatriz * cantidadTotal);

          return round2Decimals(costoMatriz * cantidadTotal);
        }

        let totalPartida = 0;

        if (partida.children && partida.tipo !== 1) {
          for (const partidaChildren of partida.children) {
            const total = traversePartidas(
              partidaChildren,
              cantidadAcumulada * partida.cantidad,
            );
            totalPartida += total;
          }
        }

        if (partida.tipo === 0) {
          lineasDescargarPdf.push([
            { text: "", style: "textoTabla", alignment: "center" },
            {
              text: "TOTAL " + partida.nombre,
              style: "textoTablaBold",
              alignment: "left",
            },
            { text: "", style: "textoTabla", alignment: "center" },
            { text: "", style: "textoTabla", alignment: "center" },
            { text: "", style: "textoTabla", alignment: "center" },
            {
              text: round2Decimals(totalPartida),
              style: "textoTablaBold",
              alignment: "right",
            },
            { text: "", style: "textoTabla", alignment: "right" },
          ]);
        }

        return totalPartida;
      };

      const partidas = [...this.state.partidas];

      if (partidas) {
        for (const partida of partidas) {
          traversePartidas(partida, 1);
        }
      }

      for (const linea of lineasDescargarPdf) {
        if ((linea[5]?.text || linea[5]?.text === 0) && linea[6]?.text === "") {
          const porcentaje = (linea[5].text / totalPresupuesto) * 100;

          linea[6].text = round2Decimals(porcentaje) + "%";
          linea[5].text = dineroDisabledMask(linea[5].text);
        }
      }

      lineasDescargarPdf.push([{}, {}, {}, {}, {}, {}, {}]);

      lineasDescargarPdf.push([
        {
          text: "TOTAL DEL PRESUPUESTO",
          colSpan: 5,
          style: "textoTablaBold",
          alignment: "center",
        },
        {},
        {},
        {},
        {},
        {
          text: dineroDisabledMask(totalPresupuesto),
          colSpan: 2,
          style: "textoTablaBold",
          alignment: "center",
        },
        {},
      ]);

      lineasDescargarPdf.push([
        {
          text: numeroALetra(totalPresupuesto, "MXN"),
          colSpan: 7,
          style: "textoTablaBold",
          alignment: "center",
        },
        {},
        {},
        {},
        {},
        {},
        {},
      ]);

      axios
        .post(
          "presupuestosPU/selectDatosParaPdf",
          { empresaId: this.props.empresaId },
          {
            headers: this.props.headersToken,
          },
        )
        .then((res) => {
          if (res.data.success === 2) {
            const pdf = reportePresupuestoPUPdf({
              fechaFinal,
              fechaInicio,
              presupuestos: lineasDescargarPdf,
              nombrePresupuesto: nombre,
              empresa: res.data.empresa,
              logoBiwo: res.data.logoBiwo,
            });

            pdfMake
              .createPdf(pdf)
              .download(`PRESUPUESTO ${nombre ? nombre : ""}.pdf`);

            this.setState({ loadingReportes: false });
          } else {
            MensajeError({ message: "No se pudo descargar el reporte" });
          }
        });
    } else if (tipo === "excel") {
      let mergesHoja = [];

      let rowsHoja = [];

      const allBorders = {
        top: { style: "thin", color: { auto: 1 } },
        bottom: { style: "thin", color: { auto: 1 } },
        left: { style: "thin", color: { auto: 1 } },
        right: { style: "thin", color: { auto: 1 } },
      };

      const topBorder = {
        top: { style: "thin", color: { auto: 1 } },
      };

      // const noBorders = {
      //     top: { style: 'none' },
      //     bottom: { style: 'none' },
      //     left: { style: 'none' },
      //     right: { style: 'none' },
      // };

      let lineasDescargarHoja = [];

      //Encabezado

      lineasDescargarHoja.push([]);

      lineasDescargarHoja.push([
        {
          v: "PRESUPUESTO",
          t: "s",
          s: {
            font: { bold: true, sz: 14 },
            alignment: { horizontal: "center" },
          },
        },
        {
          v: "",
          t: "s",
          s: { font: { bold: true }, alignment: { horizontal: "center" } },
        },
        {
          v: "",
          t: "s",
          s: { font: { bold: true }, alignment: { horizontal: "center" } },
        },
        {
          v: "",
          t: "s",
          s: { font: { bold: true }, alignment: { horizontal: "center" } },
        },
        {
          v: "",
          t: "s",
          s: { font: { bold: true }, alignment: { horizontal: "center" } },
        },
        {
          v: "",
          t: "s",
          s: { font: { bold: true }, alignment: { horizontal: "center" } },
        },
        {
          v: "",
          t: "s",
          s: { font: { bold: true }, alignment: { horizontal: "center" } },
        },
      ]);

      mergesHoja.push(XLSXStyle.utils.decode_range("A2:G2"));

      lineasDescargarHoja.push([]);

      lineasDescargarHoja.push([
        {
          v: "Código",
          t: "s",
          s: {
            font: { bold: true },
            alignment: { horizontal: "center" },
            border: allBorders,
          },
        },
        {
          v: "Concepto",
          t: "s",
          s: {
            font: { bold: true },
            alignment: { horizontal: "center" },
            border: allBorders,
          },
        },
        {
          v: "Unidad",
          t: "s",
          s: {
            font: { bold: true },
            alignment: { horizontal: "center" },
            border: allBorders,
          },
        },
        {
          v: "Cantidad",
          t: "s",
          s: {
            font: { bold: true },
            alignment: { horizontal: "center" },
            border: allBorders,
          },
        },
        {
          v: "P. Unitario",
          t: "s",
          s: {
            font: { bold: true },
            alignment: { horizontal: "center" },
            border: allBorders,
          },
        },
        {
          v: "Importe",
          t: "s",
          s: {
            font: { bold: true },
            alignment: { horizontal: "center" },
            border: allBorders,
          },
        },
        {
          v: "%",
          t: "s",
          s: {
            font: { bold: true },
            alignment: { horizontal: "center" },
            border: allBorders,
          },
        },
      ]);

      let totalPresupuesto = 0;

      const traversePartidas = (partida, cantidadAcumulada = 1) => {
        if (partida.tipo === 0) {
          lineasDescargarHoja.push([
            { v: "", t: "s", s: { alignment: { horizontal: "left" } } },
            {
              v: partida.nombre,
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "left" } },
            },
            { v: "", t: "s", s: { alignment: { horizontal: "left" } } },
            { v: "", t: "s", s: { alignment: { horizontal: "left" } } },
            { v: "", t: "s", s: { alignment: { horizontal: "left" } } },
            { v: "", t: "s", s: { alignment: { horizontal: "left" } } },
            { v: "", t: "s", s: { alignment: { horizontal: "left" } } },
          ]);
        } else {
          const matrizBuscar = this.state.todasMatrices.find(
            (valueTM) => valueTM._id.toString() === partida.nombre.toString(),
          );

          const cantidadTotal = round10Decimals(
            cantidadAcumulada * partida.cantidad,
          );

          rowsHoja[lineasDescargarHoja.length] = { hpx: 45 };

          //Indirectos

          let costoMatriz = calcularConImpuestos
            ? partida.costoCImpuestos
            : partida.costo;

          if (calcularConIndirectos && indirectos && indirectos.length > 0) {
            for (const indirecto of indirectos) {
              let costoIndirecto = 0;

              if (indirecto.calculo === 1) {
                //Sobre Total

                costoIndirecto =
                  (calcularConImpuestos
                    ? partida.costoCImpuestos
                    : partida.costo) *
                  (indirecto.porcentaje / 100);
              } else if (indirecto.calculo === 2) {
                //Sobre Acumulado

                costoIndirecto = costoMatriz * (indirecto.porcentaje / 100);
              }

              costoMatriz = round2Decimals(costoMatriz + costoIndirecto);
            }
          }

          lineasDescargarHoja.push([
            {
              v: matrizBuscar.clave ? matrizBuscar.clave : "",
              t: "s",
              s: {
                alignment: {
                  horizontal: "left",
                  wrapText: true,
                  vertical: "top",
                },
              },
            },
            {
              v: matrizBuscar.descripcion,
              t: "s",
              s: {
                alignment: {
                  horizontal: "left",
                  wrapText: true,
                  vertical: "top",
                },
              },
            },
            {
              v: matrizBuscar.unidad.nombre,
              t: "s",
              s: { alignment: { horizontal: "left", vertical: "top" } },
            },
            {
              v: cantidadTotal,
              t: "s",
              s: { alignment: { horizontal: "right", vertical: "top" } },
            },
            {
              v: dineroDisabledMask(costoMatriz),
              t: "s",
              s: { alignment: { horizontal: "right", vertical: "top" } },
            },
            {
              v: round2Decimals(costoMatriz * cantidadTotal),
              t: "s",
              s: { alignment: { horizontal: "right", vertical: "top" } },
            },
            {
              v: "",
              t: "s",
              s: { alignment: { horizontal: "right", vertical: "top" } },
            },
          ]);

          totalPresupuesto += round2Decimals(costoMatriz * cantidadTotal);

          return round2Decimals(costoMatriz * cantidadTotal);
        }

        let totalPartida = 0;

        if (partida.children && partida.tipo !== 1) {
          for (const partidaChildren of partida.children) {
            const total = traversePartidas(
              partidaChildren,
              cantidadAcumulada * partida.cantidad,
            );
            totalPartida += total;
          }
        }

        if (partida.tipo === 0) {
          lineasDescargarHoja.push([
            { v: "", t: "s", s: { alignment: { horizontal: "left" } } },
            {
              v: "TOTAL " + partida.nombre,
              t: "s",
              s: { font: { bold: true }, alignment: { horizontal: "left" } },
            },
            { v: "", t: "s", s: { alignment: { horizontal: "left" } } },
            { v: "", t: "s", s: { alignment: { horizontal: "left" } } },
            { v: "", t: "s", s: { alignment: { horizontal: "left" } } },
            {
              v: round2Decimals(totalPartida),
              t: "s",
              s: {
                font: { bold: true },
                alignment: { horizontal: "right" },
                border: topBorder,
              },
            },
            {
              v: "",
              t: "s",
              s: {
                alignment: { horizontal: "right" },
                font: { bold: true },
                border: topBorder,
              },
            },
          ]);
        }

        return totalPartida;
      };

      const partidas = [...this.state.partidas];

      if (partidas) {
        for (const partida of partidas) {
          traversePartidas(partida, 1);
        }
      }

      for (const linea of lineasDescargarHoja) {
        if ((linea[5]?.v || linea[5]?.v === 0) && linea[6]?.v === "") {
          const porcentaje = (linea[5].v / totalPresupuesto) * 100;

          linea[6].v = round2Decimals(porcentaje) + "%";
          linea[5].v = dineroDisabledMask(linea[5].v);
        }
      }

      lineasDescargarHoja.push([]);

      lineasDescargarHoja.push([
        {
          v: "TOTAL DEL PRESUPUESTO",
          t: "s",
          s: {
            font: { bold: true, sz: 14 },
            alignment: { horizontal: "left" },
          },
        },
        {
          v: "",
          t: "s",
          s: { font: { bold: true }, alignment: { horizontal: "center" } },
        },
        {
          v: "",
          t: "s",
          s: { font: { bold: true }, alignment: { horizontal: "center" } },
        },
        {
          v: "",
          t: "s",
          s: { font: { bold: true }, alignment: { horizontal: "center" } },
        },
        {
          v: "",
          t: "s",
          s: { font: { bold: true }, alignment: { horizontal: "center" } },
        },
        {
          v: dineroDisabledMask(totalPresupuesto),
          t: "s",
          s: {
            font: { bold: true, sz: 14 },
            alignment: { horizontal: "right" },
          },
        },
        {
          v: "",
          t: "s",
          s: { font: { bold: true }, alignment: { horizontal: "center" } },
        },
      ]);

      mergesHoja.push(
        XLSXStyle.utils.decode_range(
          "A" + lineasDescargarHoja.length + ":E" + lineasDescargarHoja.length,
        ),
      );

      lineasDescargarHoja.push([
        {
          v: numeroALetra(totalPresupuesto, "MXN"),
          t: "s",
          s: {
            font: { bold: true, sz: 14 },
            alignment: { horizontal: "left" },
          },
        },
        {
          v: "",
          t: "s",
          s: { font: { bold: true }, alignment: { horizontal: "center" } },
        },
        {
          v: "",
          t: "s",
          s: { font: { bold: true }, alignment: { horizontal: "center" } },
        },
        {
          v: "",
          t: "s",
          s: { font: { bold: true }, alignment: { horizontal: "center" } },
        },
        {
          v: "",
          t: "s",
          s: { font: { bold: true }, alignment: { horizontal: "center" } },
        },
        {
          v: "",
          t: "s",
          s: {
            font: { bold: true, sz: 14 },
            alignment: { horizontal: "center" },
          },
        },
        {
          v: "",
          t: "s",
          s: { font: { bold: true }, alignment: { horizontal: "center" } },
        },
      ]);

      mergesHoja.push(
        XLSXStyle.utils.decode_range(
          "A" + lineasDescargarHoja.length + ":G" + lineasDescargarHoja.length,
        ),
      );

      const worksheetMatrices =
        XLSXStyle.utils.aoa_to_sheet(lineasDescargarHoja);
      worksheetMatrices["!merges"] = mergesHoja;
      worksheetMatrices["!rows"] = rowsHoja;
      worksheetMatrices["!cols"] = [
        { wpx: 70 },
        { wpx: 220 },
        { wpx: 70 },
        { wpx: 70 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 70 },
      ];
      const workbook = XLSXStyle.utils.book_new();
      XLSXStyle.utils.book_append_sheet(
        workbook,
        worksheetMatrices,
        "Presupuesto",
      );

      XLSXStyle.writeFile(workbook, `PRESUPUESTO ${nombre ? nombre : ""}.xlsx`);
    }

    this.setState({ loadingReportes: false });
  }

  async calcularPresupuestoManual() {
    if (!this.state.confirmado) {
      this.setState({ loading: true });

      await this.consultarPPresupuesto();

      const partidas = [...this.state.partidas];

      const traversePartidas = (partida) => {
        if (partida.tipo === 0) {
          return {
            ...partida,
            children:
              partida?.children && partida?.children?.length > 0
                ? partida.children.map((value, index) =>
                    traversePartidas(value),
                  )
                : [],
          };
        } else {
          let childrenMatriz = [];
          let costoMatriz = 0;
          let unidad = "";

          if (partida.nombre) {
            const matriz = this.state.todasMatrices.find(
              (valueM) => valueM._id.toString() === partida.nombre.toString(),
            );
            if (!matriz) {
              throw new Error("Matriz no encontrada");
            }
            unidad = matriz.unidad.nombre;

            const obtenerHijosMatriz = (
              valueMatriz,
              indexMatriz,
              keyMatriz = partida.key,
            ) => {
              const insumoBuscar = this.state.todasInsumos.find(
                (valueTI) =>
                  valueTI._id.toString() === valueMatriz.insumoId.toString(),
              );
              if (!insumoBuscar) {
                throw new Error(
                  `Insumo no encontrado: ${valueMatriz.insumoId}`,
                );
              }
              const costoTotal = round10Decimals(
                (insumoBuscar.costo ? insumoBuscar.costo : valueMatriz.costo) *
                  (insumoBuscar.calculo
                    ? valueMatriz.cantidad / 100
                    : valueMatriz.cantidad),
              );
              costoMatriz += round10Decimals(
                (insumoBuscar.costo ? insumoBuscar.costo : valueMatriz.costo) *
                  (insumoBuscar.calculo
                    ? valueMatriz.cantidad / 100
                    : valueMatriz.cantidad),
              );

              let costoCImpuestos;

              if (!insumoBuscar.matriz) {
                let totalImpuestos = 0;

                if (
                  insumoBuscar.impuestos &&
                  insumoBuscar.impuestos.length > 0
                ) {
                  for (const valueImpuesto of insumoBuscar.impuestos) {
                    let totalImpuesto;
                    if (valueImpuesto.tasaCuota === 1) {
                      totalImpuesto = round6Decimals(
                        insumoBuscar.costo * (valueImpuesto.monto / 100),
                      );
                    } else if (valueImpuesto.tasaCuota === 2) {
                      totalImpuesto = round6Decimals(
                        (insumoBuscar.costo + totalImpuestos) *
                          (valueImpuesto.monto / 100),
                      );
                    } else if (valueImpuesto.tasaCuota === 3) {
                      totalImpuesto = round6Decimals(
                        valueMatriz.cantidad * valueImpuesto.monto,
                      );
                    } else if (valueImpuesto.tasaCuota === 4) {
                      totalImpuesto = 0;
                    } else if (valueImpuesto.tasaCuota === 5) {
                      totalImpuesto = 0;
                    }

                    totalImpuestos += totalImpuesto;
                  }
                }

                costoCImpuestos = round2Decimals(
                  (insumoBuscar.costo
                    ? insumoBuscar.costo
                    : valueMatriz.costo) + totalImpuestos,
                );
              } else {
                costoCImpuestos = insumoBuscar.costo
                  ? insumoBuscar.costo
                  : valueMatriz.costo;
              }

              return {
                insumoMatriz: true,
                calculo: insumoBuscar.calculo,
                nombre: insumoBuscar?.descripcion,
                unidad: insumoBuscar?.unidad?.nombre,
                children:
                  insumoBuscar.matriz && insumoBuscar.insumosUtilizar
                    ? insumoBuscar.insumosUtilizar.map((valueHijo, indexHijo) =>
                        obtenerHijosMatriz(
                          valueHijo,
                          indexHijo,
                          keyMatriz + "-" + indexMatriz,
                        ),
                      )
                    : undefined,
                costoTotal: costoTotal,
                costo: insumoBuscar.costo
                  ? insumoBuscar.costo
                  : valueMatriz.costo,
                costoTotalCImpuestos: round2Decimals(
                  costoCImpuestos *
                    (insumoBuscar.calculo
                      ? valueMatriz.cantidad / 100
                      : valueMatriz.cantidad),
                ),
                costoCImpuestos,
                cantidad: valueMatriz.cantidad,
                insumoId: valueMatriz.insumoId,
                key: keyMatriz + "-" + indexMatriz,
              };
            };

            childrenMatriz = matriz.insumosUtilizar.map(
              (valueMatriz, indexMatriz) =>
                obtenerHijosMatriz(valueMatriz, indexMatriz),
            );
          }

          return {
            ...partida,
            children: childrenMatriz,
            costo: costoMatriz,
            costoTotal: round2Decimals(costoMatriz * (partida.cantidad || 0)),
            unidad,
          };
        }
      };

      // Intenta calcular, y detiene si hay error
      let nuevasPartidas = [];

      try {
        nuevasPartidas = partidas.map((partida) => traversePartidas(partida));
      } catch (err) {
        console.error("Error en cálculo de partidas:", err.message);
        MensajeError({ message: "Hay un error en las matrices y no se pudo calcular" });
        return this.setState({ loading: false }); // Limpia las partidas y detiene el loading
      }

      const nuevasPartidas2 = this.calcularPresupuesto(nuevasPartidas);

      this.setState({ partidas: nuevasPartidas2, loading: false });
    }
  }

  render() {
    const columns = [
      {
        title: "Clave",
        dataIndex: "key",
        key: "key",
        width: "6%",
        render: (value, record) => {
          if (record.insumoMatriz) return "";
          const arrayKey = value.split("-").map((v) => Number(v));
          return arrayKey[1] + 1;
        },
      },
      {
        title: "Matriz",
        dataIndex: "nombre",
        key: "nombre",
        render: (value, record) => {
          if (record.tipo === 1) {
            const matriz = value ? this.matricesPorId.get(value.toString()) : null;
            if (!matriz) return "";
            return (
              <Space size={4}>
                <span>{matriz.descripcion}</span>
                {!matriz.autorizado && <Tag color="orange">Falta autorizar</Tag>}
              </Space>
            );
          }
          return value;
        },
        width: "20%",
      },
      {
        title: "Costo",
        dataIndex: "costo",
        key: "costo",
        sorter: (a, b) => {
          if (a.costo < b.costo) {
            return -1;
          }
          if (a.costo > b.costo) {
            return 1;
          }
          return 0;
        },
        render: (value) => dineroDisabledMask(value),
        width: "8%",
        align: "right",
      },
      {
        title: "Unidad",
        dataIndex: "unidad",
        key: "unidad",
        width: "7%",
        align: "left",
      },
      {
        title: "Cantidad",
        dataIndex: "cantidad",
        key: "cantidad",
        width: "8%",
        align: "left",
        render: (value, record) => {
          if (record.calculo) {
            return value + " %";
          } else {
            return value;
          }
        },
      },
      {
        title: (
          <Space size={4} style={{ whiteSpace: "nowrap" }}>
            Cant. proy.
            <Tooltip title="Cantidad total que se va a necesitar de esta matriz: la cantidad de la partida (arriba) multiplicada por la cantidad de la matriz en este renglón.">
              <ExclamationOutlined style={{ fontSize: 11, color: "#999" }} />
            </Tooltip>
          </Space>
        ),
        dataIndex: "cantidadTotal",
        key: "cantidadTotal",
        width: "10%",
        align: "left",
      },
      {
        title: "Costo",
        dataIndex: "costoTotal",
        key: "costoTotal",
        sorter: (a, b) => {
          if (a.costoTotal < b.costoTotal) {
            return -1;
          }
          if (a.costoTotal > b.costoTotal) {
            return 1;
          }
          return 0;
        },
        render: (value) => dineroDisabledMask(value),
        width: "8%",
        align: "right",
      },
      {
        title: "Costo C/I",
        dataIndex: "costoTotalCImpuestos",
        key: "costoTotalCImpuestos",
        sorter: (a, b) => {
          if (a.costoTotalCImpuestos < b.costoTotalCImpuestos) {
            return -1;
          }
          if (a.costoTotalCImpuestos > b.costoTotalCImpuestos) {
            return 1;
          }
          return 0;
        },
        render: (value) => dineroDisabledMask(value),
        width: "8%",
        align: "right",
      },
      {
        title: "Accion",
        dataIndex: "key",
        key: "key",
        width: "6%",
        align: "center",
        render: (value, record) => {
          if (record?.insumoMatriz || this.state.confirmado || this.state.autorizado) {
            return null;
          }
          const arrayKey = value.split("-").map((v) => Number(v));
          return (
            <Tooltip
              title="Quitar matriz"
              placement="top"
              overlayInnerStyle={{
                fontSize: "10px",
                padding: "1px 5px",
                minHeight: "auto",
              }}
            >
              <ButtonItem
                type="default"
                size="small"
                rojo
                icon={<MinusCircleOutlined />}
                onClick={() => this.quitarMatriz(arrayKey[0], arrayKey[1])}
              />
            </Tooltip>
          );
        },
      },
    ];

    const mergedColumns = columns.map((col) => {
      return {
        ...col,
        onCell: (record) => ({
          record,
          dataIndex: col?.dataIndex,
          title: col?.title,
        }),
      };
    });

    const menuMatrices = (
      <Menu>
        <Menu.Item
          key="1"
          onClick={() => this.descargarMatrices("excel")}
          icon={<FileExcelOutlined />}
        >
          Excel
        </Menu.Item>
        <Menu.Item
          key="2"
          onClick={() => this.descargarMatrices("pdf")}
          icon={<FilePdfOutlined />}
        >
          Pdf
        </Menu.Item>
      </Menu>
    );

    const menuPresupuesto = (
      <Menu>
        <Menu.Item
          key="1"
          onClick={() => this.descargarPresupuesto("excel")}
          icon={<FileExcelOutlined />}
        >
          Excel
        </Menu.Item>
        <Menu.Item
          key="2"
          onClick={() => this.descargarPresupuesto("pdf")}
          icon={<FilePdfOutlined />}
        >
          Pdf
        </Menu.Item>
      </Menu>
    );

    let familiaAnteriorId;
    let familiaAnteriorNombre;

    // Total de columnas del thead de explosión de insumos, usado por la fila
    // separadora entre familias (colSpan) — mismo criterio visual que en tabStyles.
    const totalColsExplosion = this.state.confirmado ? 11 : 8;

    const necesitaAutorizarAntesDeConfirmar = !!this.state.id && !this.state.autorizado;

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Presupuesto"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <Space>
              {this.state.id && this.state.autorizado && this.state.estado !== 0 && (
                <Popconfirm
                  title="Se creará una nueva versión editable de este presupuesto. ¿Continuar?"
                  onConfirm={() => this.nuevaVersionPresupuesto()}
                  okText="Si"
                  cancelText="No"
                  getPopupContainer={(trigger) => trigger.parentElement}
                >
                  <ButtonItem type="primary" className="botonAgregar" lila icon={<PlusOutlined/>}>
                    Nueva versión
                  </ButtonItem>
                </Popconfirm>
              )}
              {this.state.id &&
                !this.state.autorizado &&
                this.state.estado !== 0 &&
                this.props.permisoAutorizarVersionPresupuestoPU && (
                  <Popconfirm
                    title="Se autorizará esta versión de partidas como la vigente. ¿Continuar?"
                    onConfirm={() => this.autorizarPresupuesto()}
                    okText="Si"
                    cancelText="No"
                    getPopupContainer={(trigger) => trigger.parentElement}
                  >
                    <ButtonItem type="primary" className="botonAgregar" verde icon={<CheckOutlined/>}>
                      Autorizar
                    </ButtonItem>
                  </Popconfirm>
                )}
              <ButtonItem
                blanco
                icon={<CalculatorOutlined />}
                disabled={this.state.confirmado}
                onClick={() => this.calcularPresupuestoManual()}
                className="botonAgregar"
              >
                Calcular
              </ButtonItem>
            </Space>
          }
        />
        {this.state.versiones.length > 1 && (
          <Alert
            type="info"
            style={{ marginBottom: 10 }}
            message={
              <Space wrap>
                <span>Versiones de este presupuesto:</span>
                {this.state.versiones.map((v) => (
                  <Tag
                    key={v._id}
                    color={
                      v._id.toString() === this.state.id?.toString()
                        ? "blue"
                        : "default"
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (v._id.toString() === this.state.id?.toString())
                        return;
                      this.props.history.replace("/panel/presupuestoPU", {
                        id: v._id,
                      });
                      this.setState({ id: v._id }, () => this.consultarTodo());
                    }}
                  >
                    v{v.versionNumero}
                    {v.autorizado ? " ✓" : " (borrador)"}
                    {v.superado ? " (superada)" : ""}
                  </Tag>
                ))}
              </Space>
            }
          />
        )}
        {this.state.estado === 0 && (
          <Alert
            type="error"
            showIcon
            style={{ marginBottom: 10 }}
            message="Este presupuesto está deshabilitado"
            description="No se puede guardar, confirmar, autorizar, generar una nueva versión, generar órdenes de producción ni requerir insumos mientras esté deshabilitado. Habilítalo desde el listado de presupuestos."
          />
        )}
        {this.state.autorizado && (
          <Alert
            type="warning"
            showIcon
            style={{ marginBottom: 10 }}
            message="Este presupuesto está autorizado y sus partidas no pueden modificarse directamente. Usa 'Nueva versión' para crear una versión editable."
          />
        )}
        <div className="card-background" style={{ paddingTop: 5 }}>
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="presupuestoPU"
              layout
              bottom={
                <div style={{ display: "flex", justifyContent: "right" }}>
                  <Space>
                    {!this.state.confirmado &&
                    this.props.permisoConfirmarPresupuestoPU ? (
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                        <Popconfirm
                          title="Seguro que quieres confirmar este presupuesto, al confirmarlo no se podran editar los datos de las partidas"
                          onConfirm={() => this.confirmarPresupuesto()}
                          okText="Si"
                          cancelText="No"
                          disabled={this.state.estado === 0 || necesitaAutorizarAntesDeConfirmar}
                          getPopupContainer={(trigger) => trigger.parentElement}
                        >
                          <ButtonItem
                            verde
                            disabled={this.state.estado === 0 || necesitaAutorizarAntesDeConfirmar}
                            style={{ display: "block", margin: "0 0 0 auto" }}
                          >
                            Confirmar
                          </ButtonItem>
                        </Popconfirm>
                        {necesitaAutorizarAntesDeConfirmar && (
                          <span style={{ color: "#bfbfbf", fontSize: 12, marginTop: 4 }}>
                            Primero autoriza este presupuesto
                          </span>
                        )}
                      </div>
                    ) : null}
                    <ButtonItem
                      type="primary"
                      htmlType="submit"
                      disabled={(!this.state.confirmado && this.state.autorizado) || this.state.estado === 0}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Guardar
                    </ButtonItem>
                  </Space>
                </div>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
              // onFieldsChange={this.onFieldsChange.bind(this)}
            >
              <TabbedDynamicTable
                defaultActiveKey={"1"}
                onTabChange={(key) => {
                  if (key === "3") {
                    this.arbolPresupuesto();
                  }
                  if (key === "4") {
                    this.explosionInsumos();
                    this.setState({ valueExplosion: [] });
                  }
                  if (key === "8") {
                    this.cargarHistorialPresupuesto();
                  }
                  // if (key === '5') {
                  //     this.tablaPresupuesto()
                  // }
                }}
                tabs={[
                  {
                    key: "1",
                    label: "General",
                    forceRender: true,
                    customContent: (
                      <Row>
                        <Col span={12}>
                          <FormItem
                            label="Nombre"
                            name="nombre"
                            required
                            margin
                            pattern
                          >
                            <InputItem placeholder="Nombre" />
                          </FormItem>
                          <FormItem
                            label="Fecha Inicio"
                            name="fechaInicio"
                            required
                            margin
                            initialValue={moment()}
                          >
                            <DatePickerItem
                              allowClear={false}
                              placeholder="Fecha Inicio"
                            />
                          </FormItem>
                          <FormItem
                            label="Fecha Final"
                            name="fechaFinal"
                            required
                            margin
                            initialValue={moment()}
                          >
                            <DatePickerItem
                              allowClear={false}
                              placeholder="Fecha Final"
                            />
                          </FormItem>
                        </Col>
                        <Col span={12}>
                          <FormItem
                            label="Proyecto General"
                            name="proyectoId"
                            margin
                            required
                            tooltip="Proyecto que se usa para requerir insumos (requisiciones/producciones) de este presupuesto."
                          >
                            <SelectItem
                              disabled={this.state.confirmado}
                              placeholder="Proyecto General"
                            >
                              {this.state.objetoProyectos}
                            </SelectItem>
                          </FormItem>
                          <FormItem
                            label="Proyecto Producción"
                            name="proyectoProduccionId"
                            margin
                            required
                            tooltip="Proyecto donde se produce físicamente; prellena el 'Proyecto Producción' al generar una orden de producción."
                          >
                            <SelectItem
                              disabled={this.state.confirmado}
                              placeholder="Proyecto Producción"
                            >
                              {this.state.objetoProyectos}
                            </SelectItem>
                          </FormItem>
                        </Col>
                      </Row>
                    ),
                  },
                  {
                    key: "5",
                    label: "Partidas",
                    forceRender: true,
                    customContent: (() => {
                      const partidaEditable = !this.state.confirmado && !this.state.autorizado;
                      const piezas = this.state.partidas || [];

                      return (
                        <Spin spinning={this.state.loadingExplosion}>
                          <Collapse
                            defaultActiveKey={piezas.map((p) => p.piezaId)}
                            style={{ marginBottom: 12 }}
                          >
                            {piezas.map((partida, rootIndex) => {
                              const partidaCompleta = !!partida?.nombre && !!partida?.unidad && (partida?.cantidad || 0) > 0;
                              const tieneOrden = this.piezaTieneOrdenGenerada(partida.piezaId, rootIndex);

                              return (
                                <Panel
                                  key={partida.piezaId}
                                  header={
                                    <Space size={8}>
                                      <span>{partida?.nombre || `Pieza ${rootIndex + 1}`}</span>
                                      {partida?.unidad && (
                                        <Tag>{this.unidadesPorId.get(partida.unidad.toString()) || partida.unidad}</Tag>
                                      )}
                                      <Tag color="blue">Cantidad: {partida?.cantidad ?? 0}</Tag>
                                    </Space>
                                  }
                                  extra={
                                    partidaEditable && (
                                      <Tooltip title={tieneOrden ? "No se puede eliminar: ya tiene una orden de producción generada" : undefined}>
                                        <Popconfirm
                                          title="¿Eliminar esta pieza y todas sus matrices?"
                                          onConfirm={(e) => {
                                            e?.stopPropagation?.();
                                            this.eliminarPieza(rootIndex);
                                          }}
                                          onCancel={(e) => e?.stopPropagation?.()}
                                          disabled={tieneOrden}
                                          okText="Si"
                                          cancelText="No"
                                        >
                                          <ButtonItem
                                            type="default"
                                            size="small"
                                            rojo
                                            icon={<DeleteOutlined />}
                                            disabled={tieneOrden}
                                            onClick={(e) => e.stopPropagation()}
                                          />
                                        </Popconfirm>
                                      </Tooltip>
                                    )
                                  }
                                >
                                  <div
                                    style={{
                                      border: "1px solid rgb(235, 237, 240)",
                                      borderRadius: 4,
                                      padding: 12,
                                      marginBottom: 16,
                                    }}
                                  >
                                    <Row gutter={12} align="middle">
                                      <Col span={8}>
                                        <FormItem noStyle>
                                          <InputItem
                                            value={partida?.nombre}
                                            placeholder="Nombre de la pieza"
                                            disabled={!partidaEditable}
                                            onChange={(value) => this.onChangeNombrePartida(value, rootIndex)}
                                          />
                                        </FormItem>
                                      </Col>
                                      <Col span={6}>
                                        <FormItem noStyle>
                                          <SelectItem
                                            placeholder="Unidad"
                                            width="100%"
                                            disabled={!partidaEditable}
                                            value={partida?.unidad}
                                            onChange={(value) => this.onChangeUnidadPartida(value, rootIndex)}
                                          >
                                            {this.state.objetoUnidades}
                                          </SelectItem>
                                        </FormItem>
                                      </Col>
                                      <Col span={4}>
                                        <FormItem noStyle>
                                          <InputNumberItem
                                            key={rootIndex + "-" + partida?.cantidad}
                                            defaultValue={partida?.cantidad}
                                            placeholder="Cantidad"
                                            style={{ width: "100%" }}
                                            disabled={!partidaEditable}
                                            onBlur={(value) => this.onChangeCantidadPartida(value, rootIndex)}
                                          />
                                        </FormItem>
                                      </Col>
                                      {this.props.permisoAgregarOrdenProduccionPU && (
                                        <Col span={6} style={{ textAlign: "right" }}>
                                          <Tooltip
                                            title={
                                              this.state.estado === 0
                                                ? "Este presupuesto está deshabilitado"
                                                : !(this.state.confirmado && this.state.autorizado)
                                                ? "Confirma y autoriza el presupuesto para poder generar la orden de producción"
                                                : undefined
                                            }
                                          >
                                            <ButtonItem
                                              type="default"
                                              cyan
                                              icon={<FileDoneOutlined />}
                                              disabled={this.state.estado === 0 || !(this.state.confirmado && this.state.autorizado)}
                                              onClick={() => this.irAGenerarOrdenDeProduccion({ key: String(rootIndex), piezaId: partida.piezaId })}
                                            >
                                              Generar orden de producción
                                            </ButtonItem>
                                          </Tooltip>
                                        </Col>
                                      )}
                                    </Row>
                                  </div>
                                  <Row gutter={12} align="middle" style={{ marginBottom: 10 }}>
                                    {partidaEditable && (
                                      <Col span={8}>
                                        <SelectInsumosItem
                                          placeholder="Aplicar una matriz base (opcional)"
                                          width="100%"
                                          allowClear
                                          tiposInsumos="matrices"
                                          empresaId={this.props.empresaId}
                                          headersToken={this.props.headersToken}
                                          value={this.state.matrizBasePorPieza[partida.piezaId]?._id || partida?.matrizBaseId}
                                          insumoPreCargado={this.state.matrizBasePorPieza[partida.piezaId]}
                                          onChange={(value, matrizElegida) =>
                                            this.aplicarMatrizBaseAPieza(value, matrizElegida, rootIndex)
                                          }
                                        />
                                      </Col>
                                    )}
                                    <Col span={6}>
                                      <Tooltip title={`Tiempo para producir 1 pieza (${etiquetaUnidadTiempo(this.props.unidadTiempoProduccion)}). Si lo capturas, manda sobre el tiempo ciclo de las matrices al planear las órdenes de producción.`}>
                                        <FormItem noStyle>
                                          <InputNumberItem
                                            key={partida.piezaId + "-tc-" + (partida?.tiempoCiclo ?? "") + "-" + (this.tiempoCicloPorDefecto(partida) ?? "")}
                                            defaultValue={
                                              partida?.tiempoCiclo > 0
                                                ? minutosAUnidad(partida.tiempoCiclo, this.props.unidadTiempoProduccion)
                                                : this.tiempoCicloPorDefecto(partida) > 0
                                                ? minutosAUnidad(this.tiempoCicloPorDefecto(partida), this.props.unidadTiempoProduccion)
                                                : undefined
                                            }
                                            placeholder={`T. ciclo por pieza (${etiquetaUnidadTiempo(this.props.unidadTiempoProduccion)})`}
                                            style={{ width: "100%" }}
                                            min={0}
                                            disabled={this.state.estado === 0}
                                            onBlur={(value) => this.onChangeTiempoCicloPartida(value, rootIndex)}
                                          />
                                        </FormItem>
                                      </Tooltip>
                                    </Col>
                                    {partidaEditable && (
                                      <Col span={10}>
                                        <Tooltip title="Selecciona una matriz que tenga otras matrices dentro de sus insumos para llenar automáticamente el nombre, la unidad y las matrices de esta pieza.">
                                          <ExclamationOutlined style={{ fontSize: 12, color: "#999" }} />
                                        </Tooltip>
                                      </Col>
                                    )}
                                  </Row>
                                  <Row style={{ marginBottom: 10 }}>
                                    <Col span={24}>
                                      <TextAreaItem
                                        key={partida.piezaId + "-obs-" + (partida?.observaciones ?? "")}
                                        defaultValue={partida?.observaciones}
                                        placeholder="Observaciones de la pieza"
                                        autoSize={{ minRows: 1, maxRows: 4 }}
                                        disabled={this.state.estado === 0}
                                        onBlur={(value) => this.onChangeObservacionesPartida(value, rootIndex)}
                                      />
                                    </Col>
                                  </Row>
                                  {partidaEditable ? (
                                    <Tooltip
                                      title={
                                        !partidaCompleta
                                          ? "Completa nombre, unidad y cantidad de la pieza antes de agregar matrices"
                                          : undefined
                                      }
                                    >
                                      <ButtonItem
                                        type="primary"
                                        icon={<PlusOutlined />}
                                        disabled={!partidaCompleta}
                                        onClick={() => this.agregarMatriz(rootIndex)}
                                        style={{ marginBottom: 10 }}
                                      >
                                        Agregar matriz
                                      </ButtonItem>
                                    </Tooltip>
                                  ) : undefined}
                                  <TableItem
                                    components={
                                      this.state.confirmado || this.state.autorizado
                                        ? undefined
                                        : {
                                            body: {
                                              cell: this.Cell,
                                            },
                                          }
                                    }
                                    rowKey={(value) => value.key}
                                    size="small"
                                    rowClassName={(record) => (record.insumoMatriz ? "fila-bom-pu" : "fila-matriz-pu")}
                                    expandable={{
                                      expandedRowKeys: this.state.expandedRowKeys,
                                      onExpandedRowsChange:
                                        this.onExpandedRowsChange.bind(this),
                                    }}
                                    dataSource={this.filasDePieza(partida)}
                                    columns={mergedColumns}
                                  />
                                </Panel>
                              );
                            })}
                          </Collapse>
                          {partidaEditable && (
                            <ButtonItem
                              type="dashed"
                              icon={<PlusOutlined />}
                              onClick={() => this.agregarPieza()}
                              block
                            >
                              Agregar pieza
                            </ButtonItem>
                          )}
                        </Spin>
                      );
                    })(),
                  },
                  {
                    key: "2",
                    label: "Indirectos",
                    forceRender: true,
                    customContent: (
                      <Row>
                        <Col span={24}>
                          <FormInitial.List name="indirectos">
                            {(fields, { add, remove }) => {
                              const columnsIndirectos = [
                                {
                                  title: "Nombre",
                                  dataIndex: "nombre",
                                  key: "nombre",
                                  width: "30%",
                                  render: (value, field) => (
                                    <FormItem
                                      name={[field.name, "nombre"]}
                                      fieldKey={[field.fieldKey, "nombre"]}
                                      required
                                      margin
                                      noStyle
                                    >
                                      <InputItem placeholder="Nombre" />
                                    </FormItem>
                                  ),
                                },
                                {
                                  title: "Calculo",
                                  dataIndex: "calculo",
                                  key: "calculo",
                                  width: "30%",
                                  render: (value, field) => (
                                    <FormItem
                                      name={[field.name, "calculo"]}
                                      fieldKey={[field.fieldKey, "calculo"]}
                                      initialValue={1}
                                      required
                                      margin
                                      noStyle
                                    >
                                      <SelectItem
                                        width="100%"
                                        placeholder="Calculo"
                                      >
                                        <Option value={1}>Total</Option>
                                        <Option value={2}>Acumulado</Option>
                                      </SelectItem>
                                    </FormItem>
                                  ),
                                },
                                {
                                  title: "Porcentaje",
                                  dataIndex: "porcentaje",
                                  key: "porcentaje",
                                  width: "30%",
                                  render: (value, field) => (
                                    <FormItem
                                      name={[field.name, "porcentaje"]}
                                      fieldKey={[field.fieldKey, "porcentaje"]}
                                      required
                                      margin
                                      noStyle
                                    >
                                      <InputNumberItem porcentaje />
                                    </FormItem>
                                  ),
                                },
                                {
                                  title: "",
                                  dataIndex: "accion",
                                  key: "accion",
                                  width: "10%",
                                  render: (value, field) => (
                                    <div style={{ textAlign: "center" }}>
                                      <MinusCircleOutlined
                                        onClick={() => remove(field.name)}
                                      />
                                    </div>
                                  ),
                                },
                              ];

                              return (
                                <>
                                  <TableItem
                                    rowKey={(field) => field.key}
                                    size="small"
                                    dataSource={fields}
                                    columns={columnsIndirectos}
                                  />
                                  <div
                                    style={{
                                      textAlign: "center",
                                      marginTop: 10,
                                    }}
                                  >
                                    <ButtonItem
                                      type="primary"
                                      onClick={() => add()}
                                      icon={<PlusOutlined />}
                                    >
                                      Agregar
                                    </ButtonItem>
                                  </div>
                                </>
                              );
                            }}
                          </FormInitial.List>
                        </Col>
                      </Row>
                    ),
                  },
                  {
                    key: "4",
                    label: "Explosion de insumos",
                    customContent: (
                      <Spin spinning={this.state.loadingExplosion}>
                        <Row>
                          <Col span={24}>
                            <TreeSelectItem
                              showSearch
                              style={{
                                width: "100%",
                              }}
                              // value={value}
                              dropdownStyle={{
                                maxHeight: 400,
                                overflow: "auto",
                              }}
                              multiple
                              placeholder="Selecciona piezas o matrices (déjalo vacío para explotar todo el presupuesto)"
                              allowClear
                              treeDefaultExpandAll
                              onDropdownVisibleChange={(v) =>
                                this.onChangeExplosion(
                                  this.state.valueExplosion,
                                  !v,
                                )
                              }
                              onDeselect={(v, value) => {
                                let arrayKeys = [...this.state.valueExplosion];
                                let index = arrayKeys.indexOf(value.key);

                                // If the element is found, remove it
                                if (index !== -1) {
                                  arrayKeys.splice(index, 1);
                                }
                                this.onChangeExplosion(arrayKeys, true);
                              }}
                              value={this.state.valueExplosion}
                              onChange={(value) =>
                                this.onChangeExplosion(value, false)
                              }
                              treeData={this.state.partidasArbol}
                              fieldNames={{ value: "key" }}
                            />
                          </Col>
                        </Row>
                        <table className="table table-12px">
                          {this.state.insumosExplosionados.length > 0 ? (
                            <thead>
                              <tr>
                                <th
                                  className="th-border"
                                  style={{ width: "30%" }}
                                >
                                  Insumo
                                </th>
                                <th
                                  className="th-border"
                                  style={{ width: "10%" }}
                                >
                                  Unidad
                                </th>
                                <th
                                  className="th-border"
                                  style={{ width: "10%" }}
                                >
                                  Costo Unitario
                                </th>
                                <th
                                  className="th-border"
                                  style={{ width: "10%" }}
                                >
                                  Inv. Gral.
                                </th>
                                <th
                                  className="th-border"
                                  style={{ width: "10%" }}
                                >
                                  Inv. Producción
                                </th>
                                <th
                                  className="th-border"
                                  style={{ width: "10%" }}
                                >
                                  Cantidad
                                </th>
                                <th
                                  className="th-border"
                                  style={{ width: "10%" }}
                                >
                                  Min. C
                                </th>
                                {this.state.confirmado ? (
                                  <>
                                    <th
                                      className="th-border"
                                      style={{ width: "10%" }}
                                    >
                                      Pedido
                                    </th>
                                    <th
                                      className="th-border"
                                      style={{ width: "10%" }}
                                    >
                                      Pedir
                                      <Tooltip title="Calcular lo sobrante">
                                        <CalculatorOutlined
                                          onClick={() => this.pedirTotales()}
                                          style={{
                                            marginLeft: "5px",
                                            color: "#00b5e2",
                                          }}
                                        />
                                      </Tooltip>
                                      <Tooltip title="Calcular con minimos de compra">
                                        <CalculatorOutlined
                                          onClick={() =>
                                            this.pedirMinCompraTotales()
                                          }
                                          style={{
                                            marginLeft: "5px",
                                            color: "red",
                                          }}
                                        />
                                      </Tooltip>
                                    </th>
                                    <th
                                      className="th-border"
                                      style={{ width: "10%" }}
                                    >
                                      Costo
                                    </th>
                                  </>
                                ) : null}
                                <th
                                  className="th-border"
                                  style={{ width: "10%" }}
                                >
                                  Costo T
                                </th>
                              </tr>
                            </thead>
                          ) : null}
                          {this.state.insumosExplosionados.map(
                            (valueInsumo, index) => {
                              const mostrarFamilia =
                                valueInsumo.familiaId !== familiaAnteriorId ||
                                index === 0;
                              const esNuevaFamilia =
                                mostrarFamilia && index !== 0;
                              familiaAnteriorId = valueInsumo.familiaId;
                              familiaAnteriorNombre = valueInsumo.familiaNombre;
                              return (
                                <tbody key={index}>
                                  {esNuevaFamilia && (
                                    <tr>
                                      <td
                                        colSpan={totalColsExplosion}
                                        style={{
                                          height: 15,
                                          backgroundColor: "#f0f2f5",
                                        }}
                                      ></td>
                                    </tr>
                                  )}
                                  {mostrarFamilia ? (
                                    <tr
                                      style={{
                                        backgroundColor: "#e6f7ff",
                                        borderTop: "2px solid #1890ff",
                                      }}
                                    >
                                      <td
                                        className="td-border"
                                        colSpan="8"
                                        style={{
                                          textAlign: "left",
                                          padding: "8px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontWeight: "bold",
                                            color: "#096dd9",
                                            fontSize: "1.1em",
                                          }}
                                        >
                                          {familiaAnteriorNombre
                                            ? familiaAnteriorNombre
                                            : "Sin Familia"}
                                        </span>
                                      </td>
                                      {this.state.confirmado ? (
                                        <td
                                          className="th-border"
                                          style={{ width: "10%" }}
                                        >
                                          <Tooltip title="Calcular lo sobrante de la familia">
                                            <CalculatorOutlined
                                              onClick={() =>
                                                this.pedirTotalesFamilia(
                                                  valueInsumo.familiaId,
                                                )
                                              }
                                              style={{
                                                marginLeft: "5px",
                                                color: "#00b5e2",
                                              }}
                                            />
                                          </Tooltip>
                                          <Tooltip title="Calcular con minimos de compra de la familia">
                                            <CalculatorOutlined
                                              onClick={() =>
                                                this.pedirMinCompraTotalesFamilia(
                                                  valueInsumo.familiaId,
                                                )
                                              }
                                              style={{
                                                marginLeft: "5px",
                                                color: "red",
                                              }}
                                            />
                                          </Tooltip>
                                        </td>
                                      ) : null}
                                      {this.state.confirmado && (
                                        <td
                                          className="td-border"
                                          colSpan={2}
                                        ></td>
                                      )}
                                    </tr>
                                  ) : null}
                                  <tr>
                                    <td
                                      className="td-border"
                                      style={{
                                        textAlign: "left",
                                        wordBreak: "keep-all",
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      <p style={{ margin: 5 }}>
                                        {valueInsumo.nombre}
                                      </p>
                                    </td>
                                    <td
                                      className="td-border"
                                      style={{ textAlign: "center" }}
                                    >
                                      <p style={{ margin: 5 }}>
                                        {valueInsumo.unidad}
                                      </p>
                                    </td>
                                    <td
                                      className="td-border"
                                      style={{ textAlign: "right" }}
                                    >
                                      <p style={{ margin: 5 }}>
                                        {dineroDisabledMask(valueInsumo.costo)}
                                      </p>
                                    </td>
                                    <td
                                      className="td-border"
                                      style={{ textAlign: "right" }}
                                    >
                                      <p style={{ margin: 5 }}>
                                        {valueInsumo.cantidadProyectoGeneral}
                                      </p>
                                    </td>
                                    <td
                                      className="td-border"
                                      style={{ textAlign: "right" }}
                                    >
                                      <p style={{ margin: 5 }}>
                                        {valueInsumo.cantidadProyectoProduccion}
                                      </p>
                                    </td>
                                    <td
                                      className="td-border"
                                      style={{ textAlign: "right" }}
                                    >
                                      <p style={{ margin: 5 }}>
                                        {valueInsumo.calculo
                                          ? round4Decimals(
                                              valueInsumo.cantidad * 100,
                                            ) + " %"
                                          : round4Decimals(
                                              valueInsumo.cantidad,
                                            )}
                                      </p>
                                    </td>
                                    <td
                                      className="td-border"
                                      style={{ textAlign: "right" }}
                                    >
                                      <p style={{ margin: 5 }}>
                                        {valueInsumo.catidadMinCompra}
                                      </p>
                                    </td>
                                    {this.state.confirmado ? (
                                      <>
                                        <td
                                          className="td-border"
                                          style={{ textAlign: "right" }}
                                        >
                                          <p style={{ margin: 5 }}>
                                            {round4Decimals(
                                              valueInsumo.cantidadPedida,
                                            )}
                                          </p>
                                        </td>
                                        <td
                                          className="td-border"
                                          style={{ textAlign: "right" }}
                                        >
                                          <FormItem
                                            name={
                                              "pedir" + valueInsumo.insumoId
                                            }
                                            noStyle
                                            numberCero
                                            type="number"
                                            max={round4Decimals(
                                              valueInsumo.cantidad -
                                                (valueInsumo.cantidadPedida ||
                                                  0) >
                                                0
                                                ? valueInsumo.cantidad -
                                                    (valueInsumo.cantidadPedida ||
                                                      0)
                                                : 0,
                                            )}
                                          >
                                            <InputNumberItem
                                              onChange={this.cambioPedir.bind(
                                                this,
                                              )}
                                              sinBorde
                                              style={{
                                                backgroundColor: "transparent",
                                              }}
                                              placeholder={
                                                "Max: " +
                                                round4Decimals(
                                                  valueInsumo.cantidad -
                                                    (valueInsumo.cantidadPedida ||
                                                      0) >
                                                    0
                                                    ? valueInsumo.cantidad -
                                                        (valueInsumo.cantidadPedida ||
                                                          0)
                                                    : 0,
                                                )
                                              }
                                            />
                                          </FormItem>
                                        </td>
                                        <td
                                          className="td-border"
                                          style={{ textAlign: "right" }}
                                        >
                                          <p style={{ margin: 5 }}>
                                            {dineroDisabledMask(
                                              valueInsumo.costoPedir,
                                            )}
                                          </p>
                                        </td>
                                      </>
                                    ) : null}
                                    <td
                                      className="td-border"
                                      style={{ textAlign: "right" }}
                                    >
                                      <p style={{ margin: 5 }}>
                                        {dineroDisabledMask(
                                          valueInsumo.costoTotal,
                                        )}
                                      </p>
                                    </td>
                                  </tr>
                                </tbody>
                              );
                            },
                          )}

                          <tbody key="T">
                            <tr>
                              <td
                                className="td-border"
                                style={{ textAlign: "left" }}
                              >
                                <p style={{ margin: 5 }}>Total:</p>
                              </td>
                              <td
                                className="td-border"
                                style={{ textAlign: "center" }}
                              >
                                <p style={{ margin: 5 }}></p>
                              </td>
                              <td
                                className="td-border"
                                style={{ textAlign: "center" }}
                              >
                                <p style={{ margin: 5 }}></p>
                              </td>
                              <td
                                className="td-border"
                                style={{ textAlign: "center" }}
                              >
                                <p style={{ margin: 5 }}></p>
                              </td>
                              <td
                                className="td-border"
                                style={{ textAlign: "center" }}
                              >
                                <p style={{ margin: 5 }}></p>
                              </td>
                              <td
                                className="td-border"
                                style={{ textAlign: "center" }}
                              >
                                <p style={{ margin: 5 }}></p>
                              </td>
                              {this.state.confirmado ? (
                                <>
                                  <td
                                    className="td-border"
                                    style={{ textAlign: "right" }}
                                  >
                                    <p style={{ margin: 5 }}></p>
                                  </td>
                                  <td
                                    className="td-border"
                                    style={{ textAlign: "right" }}
                                  >
                                    <p style={{ margin: 5 }}></p>
                                  </td>
                                  <td
                                    className="td-border"
                                    style={{ textAlign: "right" }}
                                  >
                                    <p style={{ margin: 5 }}></p>
                                  </td>
                                </>
                              ) : null}
                              <td
                                className="td-border"
                                style={{ textAlign: "right" }}
                              >
                                <p style={{ margin: 5 }}>
                                  {dineroDisabledMask(
                                    this.state.totalCostoPedir,
                                  )}
                                </p>
                              </td>
                              <td
                                className="td-border"
                                style={{ textAlign: "right" }}
                              >
                                <p style={{ margin: 5 }}>
                                  {dineroDisabledMask(this.state.costoTotalIE)}
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        {this.state.confirmado &&
                        this.state.estado !== 0 &&
                        this.state.partidasArbol.length > 0 ? (
                          <Popconfirm
                            title="Seguro que quieres generar una requisicion de estos insumos, si la cantidad sobresale del presupuesto se pedira una autorizacion extra"
                            onConfirm={() => this.requerirInsumos()}
                            okText="Si"
                            cancelText="No"
                            getPopupContainer={(trigger) => trigger.parentElement}
                          >
                            {this.props.permisoRequerirInsPresupuestoPU && (
                              <ButtonItem
                                blanco
                                style={{
                                  display: "block",
                                  margin: "10px 0px 0 auto",
                                }}
                              >
                                Requerir insumos
                              </ButtonItem>
                            )}
                          </Popconfirm>
                        ) : null}
                      </Spin>
                    ),
                  },
                  {
                    key: "6",
                    label: "Diagrama de gantt",
                    customContent: !this.state.id ? (
                      <Alert type="info" showIcon message="Guarda el presupuesto primero para poder ver y editar su diagrama de Gantt." />
                    ) : (
                      <GanttPresupuesto
                        partidas={this.state.partidas}
                        todasMatrices={this.state.todasMatrices}
                        presupuestoId={this.state.id}
                        empresaId={this.props.empresaId}
                        headersToken={this.props.headersToken}
                        calcularConImpuestos={this.formRef.current?.getFieldValue("calcularConImpuestos")}
                        nombrePresupuesto={this.formRef.current?.getFieldValue("nombre")}
                      />
                    ),
                  },
                  {
                    key: "7",
                    label: "Reportes",
                    customContent: (
                      <Spin spinning={this.state.loadingReportes}>
                        <Row>
                          <Col span={12}>
                            <FormItem
                              label="Con Impuestos"
                              name="calcularConImpuestos"
                              margin
                              tooltip={{
                                title:
                                  "Calcular los reportes con impuestos del costo.",
                              }}
                              initialValue={false}
                              valuePropName="checked"
                            >
                              <SwitchItem />
                            </FormItem>
                            <FormItem
                              label="Con Indirectos"
                              name="calcularConIndirectos"
                              margin
                              tooltip={{
                                title:
                                  "Calcular los reportes con los indirectos.",
                              }}
                              initialValue={true}
                              valuePropName="checked"
                            >
                              <SwitchItem />
                            </FormItem>
                          </Col>
                          <Col span={12}>
                            <Space>
                              <Tooltip title={this.state.estado === 0 ? "Este presupuesto está deshabilitado" : undefined}>
                                <Dropdown
                                  overlay={menuMatrices}
                                  trigger={["click"]}
                                  disabled={this.state.estado === 0}
                                >
                                  <ButtonItem blanco type="primary" disabled={this.state.estado === 0}>
                                    Descargar Matrices <DownOutlined />
                                  </ButtonItem>
                                </Dropdown>
                              </Tooltip>
                              <Tooltip title={this.state.estado === 0 ? "Este presupuesto está deshabilitado" : undefined}>
                                <Dropdown
                                  overlay={menuPresupuesto}
                                  trigger={["click"]}
                                  disabled={this.state.estado === 0}
                                >
                                  <ButtonItem blanco type="primary" disabled={this.state.estado === 0}>
                                    Descargar Presupuesto <DownOutlined />
                                  </ButtonItem>
                                </Dropdown>
                              </Tooltip>
                            </Space>
                          </Col>
                        </Row>
                      </Spin>
                    ),
                  },
                  ...(this.state.id
                    ? [
                        {
                          key: "8",
                          label: "Historial de explosiones",
                          customContent: (
                            <Spin spinning={this.state.loadingHistorial}>
                              {this.state.objectExplosiones &&
                              this.state.objectExplosiones.length > 0 ? (
                                <Tabs>{this.state.objectExplosiones}</Tabs>
                              ) : (
                                <p>No hay explosiones registradas</p>
                              )}
                            </Spin>
                          ),
                        },
                      ]
                    : []),
                ]}
              />
            </Form>
          </Spin>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    unidadTiempoProduccion: state.empresa.unidadTiempoProduccion,
    permisoConfirmarPresupuestoPU:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "67509579798d4e004368724f",
      )?.activado,
    permisoRequerirInsPresupuestoPU:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6750958e798d4e0043687250",
      )?.activado,
    permisoAutorizarVersionPresupuestoPU:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6aa329fba540d9e36417b0e5",
      )?.activado,
    permisoAgregarOrdenProduccionPU:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a9b303352b97b73c85edc24",
      )?.activado,
  };
};

export default connect(mapStateToProps)(PresupuestoPU);
